import moment from 'moment';
import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Button, Modal, ModalBody, ModalHeader, Progress, Tooltip } from 'reactstrap';
import language from '../../../assets/languages/language';
import Loader from '../../../common/loader';
import FrmSubscriptionCheck from '../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../RestAPI/PartnerSubscription/FrmSubscription';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import { Y_AXIS_SCALES } from '../../../common/constant';
import { renderHTMLContent, renderSanitizedHTML } from '../../../common/function';
import EmailResubscribe from '../../../components/EmailResubscribe';
import AppRoutes from '../../config/AppRoutes';
import {autorun} from "mobx";
import UserStore from "../../../store/userStore";
/* eslint-disable */
let i = '';
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      alert_status1: false,

      reportAnswerStatus: false,
      reportAnswerStatus1: false,

      reportEditStatus: false,
      reportEditStatus1: false,

      reportEditId: '',
      reportEditId1: '',

      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRM}`,
      frm1_flash_card_data: '',
      item_status: '',
      frm2_flash_card_data: '',
      item_status1: '',
      dropdownOpen: false,
      ValidToken: false,
      token: '',
      idname: '',
      flashreport: [],
      flashreport1: [],

      notesFlashReport: [],
      notesFlashReport1: [],

      savedquestion: [],
      savedquestion1: [],

      savednotes: [],
      savednotes1: [],

      contactID: '',
      contactID1: '',

      contactType: '',
      contactType1: '',

      contactIndex: '',
      contactIndex1: '',

      contactSubject: '',
      contactSubject1: '',

      contactComment: '',
      contactComment1: '',

      contactStatus: false,
      contactStatus1: false,

      successAlert: false,
      successAlert1: false,

      SubjectErrorMessage: '',
      SubjectErrorMessage1: '',

      CommentErrorMessage: '',
      CommentErrorMessage1: '',

      savedvideo: [],
      savedvideo1: [],

      progress_bar_zero: [],
      progress_bar_zero1: [],

      progress_bar: [],
      progress_bar1: [],

      reportquestion: [],
      reportquestion1: [],

      reportquestionCBT: [],
      reportquestionCBT1: [],

      reportnotes: [],
      reportnotes1: [],

      reportsvideo: [],
      reportsvideo1: [],

      main_bargraph_data: '',
      main_bargraph_data1: '',

      bar_chapter: '',
      bar_chapter1: '',

      videoFlashReport: [],
      videoFlashReport1: [],

      activeTabFlashcards: '1',
      activeTabSaved: '1',
      activeTabReports: '1',

      activeTabFlashcards1: '1',
      activeTabSaved1: '1',
      activeTabReports1: '1',

      type: '',
      type1: '',

      bar_level_main: [
        'Ethics',
        'Quants',
        'Econ',
        'FRA',
        'Corpo',
        'Portfolio',
        'Equity',
        'Fixed Income',
        'Derivatives',
        'Al',
      ],
      bar_main_user: [],
      bar_main_user1: [],

      bar_main_class: [],
      bar_main_class1: [],

      startDate: '',
      startDate_second: '',
      send_startDate: '',
      send_startDate_second: '',
      startDate1: '',
      startDate_second1: '',
      send_startDate1: '',
      send_startDate_second1: '',
      more_detail_button: `${language.LC().I_WANT_MORE_DETAILS}`,
      show_outer: 'hide_block',
      chapters: [],
      chapters1: [],
      videoReport1: '',
      subreadings_status: false,
      selectedmenufrm: 'frm',
      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
      ErrorMessage: '',
      ErrorMessage1: '',
      tooltips: [
        {
          placement: `${language.LC().SEPARATE_YOUR_RESULT}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().YOU_CAN_SEE}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().THAT_SPECIFIC_NOTES}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().SEPARATE_YOUR_RESULT}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().YOU_CAN_SEE}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().THAT_SPECIFIC_NOTES}`,
          text_align: 'left',
        },
      ],
      display_main_loader: 'show_block',
      display_loader: 'hide_block',
      showFreePremium: '',

      showFreePremium1: '',
      isVideo: true,
      showCapsules: true,
      qpLoader: true,
      npLoader: true,
      savedLoader: true,
      flashLoader: true,
      reportLoader: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);

    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggleAlert1 = this.toggleAlert1.bind(this);

    this.toggle = this.toggle.bind(this);
    this.toggle1 = this.toggle1.bind(this);

    this.toggleClose = this.toggleClose.bind(this);
    this.toggleClose1 = this.toggleClose1.bind(this);

    this.toggleDone = this.toggleDone.bind(this);
    this.toggleDone1 = this.toggleDone1.bind(this);

    this.toggleCloseReport = this.toggleCloseReport.bind(this);
    this.toggleCloseReport1 = this.toggleCloseReport1.bind(this);

    this.toggleAlertReport = this.toggleAlertReport.bind(this);
    this.toggleAlertReport1 = this.toggleAlertReport1.bind(this);

    this.CloseEditQuesReport = this.CloseEditQuesReport.bind(this);
    this.CloseEditQuesReport1 = this.CloseEditQuesReport1.bind(this);

    this.CloseEditCBTQuesReport = this.CloseEditCBTQuesReport.bind(this);
    this.CloseEditCBTQuesReport1 = this.CloseEditCBTQuesReport1.bind(this);

    this.OpenEditCBTQuesReport = this.OpenEditCBTQuesReport.bind(this);
    this.OpenEditCBTQuesReport1 = this.OpenEditCBTQuesReport1.bind(this);

    this.OpenEditQuesReport = this.OpenEditQuesReport.bind(this);
    this.OpenEditQuesReport1 = this.OpenEditQuesReport1.bind(this);

    this.CloseEditNotesReport = this.CloseEditNotesReport.bind(this);
    this.CloseEditNotesReport1 = this.CloseEditNotesReport1.bind(this);

    this.OpenEditNotesReport = this.OpenEditNotesReport.bind(this);
    this.OpenEditNotesReport1 = this.OpenEditNotesReport1.bind(this);

    this.CloseEditVideoReport = this.CloseEditVideoReport.bind(this);
    this.CloseEditVideoReport1 = this.CloseEditVideoReport1.bind(this);

    this.OpenEditVideoReport = this.OpenEditVideoReport.bind(this);
    this.OpenEditVideoReport1 = this.OpenEditVideoReport1.bind(this);

    this.onContactChange = this.onContactChange.bind(this);
    this.onContactChange1 = this.onContactChange1.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  toggle1() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  toggleAlert(card) {
    this.setState({
      alert_status: !this.state.alert_status,
      item_status: card,
    });
  }

  toggleAlert1(card) {
    this.setState({
      alert_status1: !this.state.alert_status1,
      item_status1: card,
    });
  }
  toggleAlertReport(item, data, e) {
    //console.log('tooogle', data);

    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: item.id,
      type: data,
    });
  }

  toggleAlertReport1(item, data, e) {
    this.setState({
      reportAnswerStatus1: !this.state.reportAnswerStatus1,
      reportAnswerId1: item.id,
      type1: data,
    });
  }

  deleteFlashCard = async (type, id) => {
    const { idname: id_name, token } = this.state;
    const payload = {
      id_name,
      token,
      type: type,
      question_type: '',
      exam: 'frm',
      level: '',
      item_id: id,
    };
    await FD.callAPI(`${App_data.backend_api}/question_bank_2024/deleteFlashCard`, payload);
  };

  toggleCloseReport() {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      type: '',
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      contactStatus: false,
    });
  }

  toggleCloseReport1() {
    this.setState({
      reportAnswerStatus1: !this.state.reportAnswerStatus1,
      reportAnswerId1: '',
      type1: '',
      contactID1: '',
      contactType1: '',
      contactIndex1: '',
      contactSubject1: '',
      contactComment1: '',
      SubjectErrorMessage1: '',
      CommentErrorMessage1: '',
      contactStatus1: false,
    });
  }

  onContactChange(data, index, type) {
    //console.log('dfaay', data);
    if (!this.state.contactStatus) {
      this.setState({
        contactID: data.id,
        contactType: type,
        contactIndex: index,
        contactStatus: true,
      });
    } else {
      this.setState({
        contactID: '',
        contactType: '',
        contactIndex: '',
        contactSubject: '',
        contactComment: '',
        SubjectErrorMessage: '',
        CommentErrorMessage: '',
        contactStatus: false,
      });
    }
  }

  onContactSubmit = async (event) => {
    event.preventDefault();
    if (this.state.contactSubject === '' && this.state.contactSubject.length < 1) {
      this.setState({
        displaytext: 'show_block',
        SubjectErrorMessage: "Subject can't be empty",
        isLoading: false,
      });
      return;
    }
    if (this.state.contactComment === '' && this.state.contactComment.length < 1) {
      this.setState({
        displaytext: 'show_block',
        CommentErrorMessage: "Comment can't be empty",
        isLoading: false,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    const { idname, token, contactComment, contactSubject } = this.state;
    const data = {
      idname: idname,
      token: token,
      contactComment: contactComment,
      contactSubject: contactSubject,
    };
    await FD.callAPI(App_data.backend_api + '/contact_us/sendReportHelpRequest', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            isLoading: false,
            successAlert: true,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose = (e) => {
    this.setState({
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      type: '',
    });
  };

  onContactChange1(data, index, type) {
    //console.log('dfaay', data);
    if (!this.state.contactStatus1) {
      this.setState({
        contactID1: data.id,
        contactType1: type,
        contactIndex1: index,
        contactStatus1: true,
      });
    } else {
      this.setState({
        contactID1: '',
        contactType1: '',
        contactIndex1: '',
        contactSubject1: '',
        contactComment1: '',
        SubjectErrorMessage1: '',
        CommentErrorMessage1: '',
        contactStatus1: false,
      });
    }
  }

  onContactSubmit1 = async (event) => {
    event.preventDefault();
    if (this.state.contactSubject1 === '' && this.state.contactSubject1.length < 1) {
      this.setState({
        displaytext: 'show_block',
        SubjectErrorMessage1: "Subject can't be empty",
        isLoading: false,
      });
      return;
    }
    if (this.state.contactComment1 === '' && this.state.contactComment1.length < 1) {
      this.setState({
        displaytext: 'show_block',
        CommentErrorMessage1: "Comment can't be empty",
        isLoading: false,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    const { idname, token, contactComment1, contactSubject1 } = this.state;
    const data = {
      idname: idname,
      token: token,
      contactComment: contactComment1,
      contactSubject: contactSubject1,
    };
    await FD.callAPI(App_data.backend_api + '/contact_us/sendReportHelpRequest', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            isLoading: false,
            successAlert1: true,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose1 = (e) => {
    this.setState({
      contactID1: '',
      contactType1: '',
      contactIndex1: '',
      contactSubject1: '',
      contactComment1: '',
      contactStatus1: false,
      successAlert1: false,
      reportAnswerStatus1: !this.state.reportAnswerStatus1,
      reportAnswerId1: '',
      type1: '',
    });
  };

  OpenEditQuesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      quesReport: item.comment,
      type: 'quesReport',
    });
  }

  OpenEditQuesReport1(item, e) {
    this.setState({
      reportEditStatus1: !this.state.reportEditStatus1,
      reportEditId1: item.id,
      quesReport1: item.comment,
      type1: 'quesReport1',
    });
  }

  OpenEditCBTQuesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      cbtquesReport: item.comment,
      type: 'cbtquesReport',
    });
  }

  OpenEditCBTQuesReport1(item, e) {
    this.setState({
      reportEditStatus1: !this.state.reportEditStatus1,
      reportEditId1: item.id,
      cbtquesReport1: item.comment,
      type1: 'cbtquesReport1',
    });
  }

  OpenEditNotesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      notesReport: item.comment,
      type: 'notesReport',
    });
  }

  OpenEditNotesReport1(item, e) {
    this.setState({
      reportEditStatus1: !this.state.reportEditStatus1,
      reportEditId1: item.id,
      notesReport1: item.comment,
      type1: 'notesReport1',
    });
  }

  OpenEditVideoReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      videoReport: item.comment,
      type: 'videoReport',
    });
  }

  OpenEditVideoReport1(item, e) {
    //console.log('hiiiiiiiiiiiiiiiiiiiiiii', item, this.state.reportEditStatus1);
    this.setState(
      {
        reportEditStatus1: !this.state.reportEditStatus1,
        reportEditId1: item.id,
        videoReport1: item.comment,
        type1: 'videoReport1',
      },
      () => {
        //console.log('in callback', this.state.reportEditStatus1);
      },
    );
  }

  CloseEditQuesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      quesReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  CloseEditQuesReport1() {
    this.setState({
      reportEditStatus1: !this.state.reportEditStatus1,
      reportEditId1: '',
      quesReport1: '',
      type1: '',
      ErrorMessage1: '',
    });
  }

  CloseEditCBTQuesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      cbtquesReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  CloseEditCBTQuesReport1() {
    this.setState({
      reportEditStatus1: !this.state.reportEditStatus1,
      reportEditId1: '',
      cbtquesReport1: '',
      type1: '',
      ErrorMessage1: '',
    });
  }

  CloseEditNotesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      notesReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  CloseEditNotesReport1() {
    this.setState({
      reportEditStatus1: !this.state.reportEditStatus1,
      reportEditId1: '',
      notesReport1: '',
      type1: '',
      ErrorMessage1: '',
    });
  }

  CloseEditVideoReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      videoReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  CloseEditVideoReport1() {
    this.setState({
      reportEditStatus1: !this.state.reportEditStatus1,
      reportEditId1: '',
      videoReport1: '',
      type1: '',
      ErrorMessage1: '',
    });
  }
  toggleClose() {
    this.setState({
      alert_status: !this.state.alert_status,
      frm1_flash_card_data: '',
      item_status: '',
    });
  }

  toggleClose1() {
    this.setState({
      alert_status1: !this.state.alert_status1,
      frm2_flash_card_data: '',
      item_status1: '',
    });
  }

  toggleDone = async () => {
    const { idname, token, frm1_flash_card_data, item_status } = this.state;
    const { question_id, item_id, video_id } = frm1_flash_card_data;
    // eslint-disable-next-line
    if (this.state.item_status === 'Notesflashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.frm1_flash_card_data,
      };
      await FD.callAPI(App_data.backend_api + '/frm_notes/deleteFlashCardD', data).then(
        async (resp) => {
          if (resp.success) {
            await this.getNotesSaved();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (this.state.item_status === 'flashcard') {
      var datas = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.frm1_flash_card_data,
      };
      await FD.callAPI(App_data.backend_api + '/frm_question_bank/deleteFlashCard', datas).then(
        async (resp) => {
          if (resp.success) {
            await this.getQuestionSaved();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (item_status === 'savedquestion') {
      var data1 = {
        token,
        idname,
        save_question: frm1_flash_card_data,
      };
      await this.deleteFlashCard('question', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/frm_question_bank/deleteSavequestion', data1).then(
        async (resp) => {
          if (resp.success) {
            await this.getQuestionSaved();
          } else {
            //console.log('error');
          }
        },
      );
    }

    if (item_status === 'savednotes') {
      var data2 = {
        token,
        idname,
        save_question: frm1_flash_card_data,
      };
      await this.deleteFlashCard('notes', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/frm_notes/deleteSaveNotes', data2).then(
        async (resp) => {
          if (resp.success) {
            await this.getNotesSaved();
          } else {
            //console.log('error');
          }
        },
      );
    }

    if (item_status === 'savedvideo') {
      var data3 = {
        token,
        idname,
        save_question: frm1_flash_card_data,
      };
      await this.deleteFlashCard('video', video_id ? video_id : item_id);
      await FD.callAPI(App_data.backend_api + '/frm_question_bank/deleteSaveVideo', data3).then(
        async (resp) => {
          if (resp.success) {
            await this.getVideosSaved();
          } else {
            //console.log('error');
          }
        },
      );
    }

    if (this.state.item_status === 'Videoflashcard') {
      var data4 = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.frm1_flash_card_data,
      };
      await FD.callAPI(
        App_data.backend_api + '/frm_question_bank/deleteDashboardVideoFlashCard',
        data4,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getVideosSaved();
        } else {
          //console.log('error');
        }
      });
    }

    if (this.state.item_status === 'Reportsquestion') {
      var data5 = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.frm1_flash_card_data,
      };
      await FD.callAPI(
        App_data.backend_api + '/frm_question_bank/deleteDashboardQuestionReports',
        data5,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getQuestionReports();
        } else {
          //console.log('error');
        }
      });
    }
    if (this.state.item_status == 'CBTreportsquestion') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.frm1_flash_card_data,
      };
      await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/deleteReport', data).then(
        async (resp) => {
          if (resp.success) {
            await this.getCBTQestionReports();
          } else {
            //console.log('error');
          }
        },
      );
    }

    if (this.state.item_status === 'Reportsnotes') {
      var data6 = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.frm1_flash_card_data,
      };
      await FD.callAPI(App_data.backend_api + '/frm_notes/deleteDashboardNotesReports', data6).then(
        async (resp) => {
          if (resp.success) {
            await this.getNotesReports();
          } else {
            //console.log('error');
          }
        },
      );
    }

    if (this.state.item_status === 'Reportsvideos') {
      var data7 = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.frm1_flash_card_data,
      };
      await FD.callAPI(
        App_data.backend_api + '/frm_question_bank/deleteDashboardVideoReports',
        data7,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getVideoReports();
        } else {
          //console.log('error');
        }
      });
    }

    this.setState({
      alert_status: false,
    });
  };

  toggleDone1 = async () => {
    const { idname, token, frm2_flash_card_data, item_status1 } = this.state;
    const { question_id, item_id, video_id } = frm2_flash_card_data;
    if (this.state.item_status1 === 'Notesflashcard1') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.frm2_flash_card_data,
      };
      await FD.callAPI(App_data.backend_api + '/frm_notes/deleteFlashCardD', data).then(
        async (resp) => {
          if (resp.success) {
            await this.getNotesSaved1();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (this.state.item_status1 === 'flashcard1') {
      var data1 = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.frm2_flash_card_data,
      };
      await FD.callAPI(App_data.backend_api + '/frm_question_bank/deleteFlashCard', data1).then(
        async (resp) => {
          if (resp.success) {
            await this.getQuestionSaved1();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (this.state.item_status1 === 'Videoflashcard1') {
      var data6 = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.frm2_flash_card_data,
      };
      await FD.callAPI(
        App_data.backend_api + '/frm_question_bank/deleteDashboardVideoFlashCard',
        data6,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getVideosSaved1();
        } else {
          //console.log('error');
        }
      });
    }
    if (item_status1 === 'savedvideo1') {
      var data7 = {
        token,
        idname,
        save_question: frm2_flash_card_data,
      };

      await this.deleteFlashCard('video', video_id ? video_id : item_id);
      await FD.callAPI(App_data.backend_api + '/frm_question_bank/deleteSaveVideo', data7).then(
        async (resp) => {
          if (resp.success) {
            await this.getVideosSaved1();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (item_status1 === 'savedquestion1') {
      var data2 = {
        token,
        idname,
        save_question: frm2_flash_card_data,
      };
      await this.deleteFlashCard('question', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/frm_question_bank/deleteSavequestion', data2).then(
        async (resp) => {
          if (resp.success) {
            await this.getQuestionSaved1();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (item_status1 === 'savednotes1') {
      const data3 = {
        token,
        idname,
        save_question: frm2_flash_card_data,
      };
      await this.deleteFlashCard('notes', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/frm_notes/deleteSaveNotes', data3).then(
        async (resp) => {
          if (resp.success) {
            await this.getNotesSaved1();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (this.state.item_status1 === 'Reportsquestion1') {
      var data4 = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.frm2_flash_card_data,
      };
      await FD.callAPI(
        App_data.backend_api + '/frm_question_bank/deleteDashboardQuestionReports',
        data4,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getQuestionReports1();
        } else {
          //console.log('error');
        }
      });
    }
    if (this.state.item_status1 == 'CBTreportsquestion1') {
      var dataa = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.frm2_flash_card_data,
      };
      await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/deleteReport', dataa).then(
        async (resp) => {
          if (resp.success) {
            await this.getCBTQestionReports1();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (this.state.item_status1 === 'Reportsnotes1') {
      var data5 = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.frm2_flash_card_data,
      };
      FD.callAPI(App_data.backend_api + '/frm_notes/deleteDashboardNotesReports', data5).then(
        async (resp) => {
          if (resp.success) {
            await this.getNotesReports1();
          } else {
            //console.log('error');
          }
        },
      );
    }
    if (this.state.item_status1 === 'Reportsvideos1') {
      var data8 = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.frm2_flash_card_data,
      };
      await FD.callAPI(
        App_data.backend_api + '/frm_question_bank/deleteDashboardVideoReports',
        data8,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getVideoReports1();
        } else {
          //console.log('error');
        }
      });
    }
    this.setState({
      alert_status1: false,
    });
  };

  _viewAllQuestion = () => {
    this.context.router.push({
      pathname: '/frm/viewallquestions/',
    });
  };
  _viewAllQuestion1 = () => {
    // console.log('_viewAllQuestion Working')
    this.context.router.push({
      pathname: '/frm/2/viewallquestions/',
    });
  };
  handleChange(date) {
    this.setState({
      startDate: date,
      startDate_second: '',
      send_startDate: moment(date).format('YYYY-MM-DD'),
      subreadings_status: false,
    });
  }

  handleChange1(date) {
    this.setState({
      startDate1: date,
      startDate_second1: '',
      send_startDate1: moment(date).format('YYYY-MM-DD'),
      subreadings_status1: false,
    });
  }
  handleChange_second(date) {
    if (this.state.startDate !== '') {
      this.setState(
        {
          startDate_second: date,
          send_startDate_second: moment(date).format('YYYY-MM-DD'),
          subreadings_status: true,
          display_main_loader: 'show_block',
        },
        function afterdateChange() {
          //alert('testing');
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            startDate: this.state.send_startDate,
            endDate: this.state.send_startDate_second,
            level: 1,
          };
          FD.callAPI(App_data.backend_api + '/frm_dashboard/mainProgressbar', data).then((resp) => {
            if (resp.success) {
              var dataString = JSON.stringify(resp.chapters);
              var dataReason = JSON.parse(dataString);
              var final_array_main = [];
              for (i = 0; i < dataReason.length; i++) {
                var right_answered = dataReason[i].answered_count;
                var total_question = dataReason[i].attempted_count;

                var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

                if (user_graph_val === 'NaN') {
                  final_array_main.push('0.0');
                } else {
                  final_array_main.push(user_graph_val);
                }
              }
              this.setState({
                bar_main_user: final_array_main,
                display_main_loader: 'hide_block',
              });
            } else {
              this.setState({
                display_main_loader: 'hide_block',
              });
            }
          });
          FD.callAPI(App_data.backend_api + '/frm_dashboard/mainProgressclassbar', data).then(
            (resp) => {
              if (resp.success) {
                var dataString = JSON.stringify(resp.chaptersclass);
                var dataReason = JSON.parse(dataString);
                var final_array_main = [];
                for (i = 0; i < dataReason.length; i++) {
                  var right_answered = dataReason[i].answered_count;
                  var total_question = dataReason[i].attempted_count;
                  var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({ bar_main_class: final_array_main });
                //console.log('***********'+this.state.bar_main_class+'++++++++++++');
              } else {
                //console.log(resp.success + '------------failure');
              }
            },
          );
          // FD.callAPI(App_data.backend_api+'/frm_dashboard/getProgressChapter',data).then(resp => {
          //   if(resp.success)
          //   {
          //     var chapters_1_arr=[];
          //     var first_incr=0;
          //     for(var i=0;i<resp.chapters.length;i++)
          //     {
          //       if(resp.chapters[i].level==1)
          //       {
          //         chapters_1_arr[first_incr]=resp.chapters[i];
          //         first_incr++;
          //       }
          //     }
          //     this.setState({progress_bar_zero:chapters_1_arr});
          //   }
          //   else
          //   {
          //     console.log(resp.success+'------------failure');
          //   }
          // });
          FD.callAPI(App_data.backend_api + '/frm_dashboard/getQuestionProgByUser', data).then(
            (resp) => {
              if (resp.success) {
                var chapters_1_arr = [];
                var first_incr = 0;
                for (var i = 0; i < resp.progressbarzero_data.length; i++) {
                  // eslint-disable-next-line
                  if (resp.progressbarzero_data[i].level == 1) {
                    chapters_1_arr[first_incr] = resp.progressbarzero_data[i];
                    first_incr++;
                  }
                }
                this.setState({
                  progress_bar_zero: chapters_1_arr,
                  qpLoader: false,
                });
              } else {
                //console.log(resp.success + '------------failure');
              }
            },
          );
          FD.callAPI(App_data.backend_api + '/frm_dashboard/getnotesprogByuser', data).then(
            (resp) => {
              if (resp.success) {
                var notes_1_arr = [];
                var first_incr = 0;
                for (var i = 0; i < resp.progressbar_data.length; i++) {
                  // eslint-disable-next-line
                  if (resp.progressbar_data[i].level == 1) {
                    notes_1_arr[first_incr] = resp.progressbar_data[i];
                    first_incr++;
                  }
                }

                this.setState({ progress_bar: notes_1_arr, npLoader: false });
              } else {
                //console.log(resp.success + '------------failure');
              }
            },
          );
        },
      );
    }
  }
  handleChange_second1(date) {
    // console.log("woooooooooo",date);

    if (this.state.startDate1 !== '') {
      // console.log("iffffffffffffffffffffffff");

      this.setState(
        {
          startDate_second1: date,
          send_startDate_second1: moment(date).format('YYYY-MM-DD'),
          subreadings_status1: true,
        },
        function afterdateChange() {
          //alert('testing');
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            startDate: this.state.send_startDate1,
            endDate: this.state.send_startDate_second1,
            level: 2,
          };
          FD.callAPI(App_data.backend_api + '/frm_dashboard/mainProgressbar', data).then((resp) => {
            // console.log(".mainProgressbar",resp);

            if (resp.success) {
              var dataString = JSON.stringify(resp.chapters);
              var dataReason = JSON.parse(dataString);
              var final_array_main = [];
              for (i = 0; i < dataReason.length; i++) {
                var right_answered = dataReason[i].answered_count;
                var total_question = dataReason[i].attempted_count;

                var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

                if (user_graph_val === 'NaN') {
                  final_array_main.push('0.0');
                } else {
                  final_array_main.push(user_graph_val);
                }
              }
              this.setState({ bar_main_user1: final_array_main });
              // console.log('***********'+this.state.bar_main_user+'++++++++++++');
            } else {
              //console.log(resp.success + '------------failure');
            }
          });
          this.setState({ display_main_loader: 'show_block' });
          FD.callAPI(App_data.backend_api + '/frm_dashboard/mainProgressclassbar', data).then(
            (resp) => {
              //  console.log("mainProgressclassbar",resp);

              if (resp.success) {
                this.setState({ display_main_loader: 'hide_block' });
                var dataString = JSON.stringify(resp.chaptersclass);
                var dataReason = JSON.parse(dataString);
                var final_array_main = [];
                for (i = 0; i < dataReason.length; i++) {
                  var right_answered = dataReason[i].answered_count;
                  var total_question = dataReason[i].attempted_count;
                  var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({ bar_main_class1: final_array_main });
                //console.log('***********'+this.state.bar_main_class+'++++++++++++');
              } else {
                //console.log(resp.success + '------------failure');
              }
            },
          );
          // FD.callAPI(App_data.backend_api+'/frm_dashboard/getProgressChapter',data).then(resp => {
          //   if(resp.success)
          //   {
          //     var chapters_1_arr=[];
          //     var first_incr=0;
          //     for(var i=0;i<resp.chapters.length;i++)
          //     {
          //       if(resp.chapters[i].level==2)
          //       {
          //         chapters_1_arr[first_incr]=resp.chapters[i];
          //         first_incr++;
          //       }
          //     }
          //     this.setState({progress_bar_zero:chapters_1_arr});
          //   }
          //   else
          //   {
          //     console.log(resp.success+'------------failure');
          //   }
          // });
          FD.callAPI(App_data.backend_api + '/frm_dashboard/getQuestionProgByUser', data).then(
            (resp) => {
              if (resp.success) {
                var chapters_1_arr = [];
                var first_incr = 0;
                for (var i = 0; i < resp.progressbarzero_data.length; i++) {
                  // eslint-disable-next-line
                  if (resp.progressbarzero_data[i].level == 2) {
                    chapters_1_arr[first_incr] = resp.progressbarzero_data[i];
                    first_incr++;
                  }
                }
                this.setState({
                  progress_bar_zero1: chapters_1_arr,
                  qpLoader: false,
                });
              } else {
                //console.log(resp.success + '------------failure');
              }
            },
          );
          FD.callAPI(App_data.backend_api + '/frm_dashboard/getnotesprogByuser', data).then(
            (resp) => {
              if (resp.success) {
                var notes_1_arr = [];
                var first_incr = 0;
                for (var i = 0; i < resp.progressbar_data.length; i++) {
                  // eslint-disable-next-line
                  if (resp.progressbar_data[i].level == 2) {
                    notes_1_arr[first_incr] = resp.progressbar_data[i];
                    first_incr++;
                  }
                }

                this.setState({ progress_bar1: notes_1_arr, npLoader: false });
              } else {
                //console.log(resp.success + '------------failure');
              }
            },
          );
        },
      );
    }
  }

  _deleteFlashcard = (items, e) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert('flashcard');
  };

  _deleteFlashcard1 = (items, e) => {
    // console.log("_deleteFlashcard1",items);

    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1('flashcard1');
  };

  _deleteVideoFlashcard = (items, e) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert('Videoflashcard');
  };

  _deleteVideoFlashcard1 = (items, e) => {
    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1('Videoflashcard1');
  };

  _deleteNotesFlashcard1 = (items, e) => {
    // console.log("_deleteNotesFlashcard1",items);

    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1('Notesflashcard1');
  };

  _deleteNotesFlashcard = (items, e) => {
    // console.log("_deleteNotesFlashcard",items);

    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert('Notesflashcard');
  };

  _deleteSavequestion = (items, e) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert(`${items.topic_name ? 'savedquestion' : 'flashcard'}`);
  };

  _deleteSavequestion1 = (items, e) => {
    // console.log("_deleteSavequestion1",items);

    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1(items.topic_name ? 'savedquestion1' : 'flashcard1');
  };

  _deleteSavedNotes = (items, e) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert(items.topic_name ? 'savednotes' : 'Notesflashcard');
  };

  _deleteSavedNotes1 = (items, e) => {
    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1(items.topic_name ? 'savednotes1' : 'Notesflashcard1');
  };

  _deletesavedvideo = (items, e) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert(items.topic_name ? 'savedvideo' : 'Videoflashcard');
  };

  _deletesavedvideo1 = (items, e) => {
    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1(items.topic_name ? 'savedvideo1' : 'Videoflashcard1');
  };

  _deleteReportsquestino = (items, e) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert('Reportsquestion');
  };

  _deleteReportsquestino1 = (items, e) => {
    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1('Reportsquestion1');
  };

  _deleteCBTReportsquestino = (items) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert('CBTreportsquestion');
  };

  _deleteCBTReportsquestino1 = (items) => {
    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1('CBTreportsquestion1');
  };

  _deleteReportsNotes = (items, e) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert('Reportsnotes');
  };

  _deleteReportsNotes1 = (items, e) => {
    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1('Reportsnotes1');
  };
  _deleteReportsVideo = (items, e) => {
    this.setState({ frm1_flash_card_data: items });
    this.toggleAlert('Reportsvideos');
  };

  _deleteReportsVideo1 = (items, e) => {
    this.setState({ frm2_flash_card_data: items });
    this.toggleAlert1('Reportsvideos1');
  };

  _getall = () => {
    // eslint-disable-next-line
    if (this.state.show_outer == 'hide_block') {
      this.setState({ show_outer: 'show_block' });
      this.setState({ more_detail_button: `${language.LC().Hide_details}` });
    }
    // eslint-disable-next-line
    if (this.state.show_outer == 'show_block') {
      this.setState({ show_outer: 'hide_block' });
      this.setState({
        more_detail_button: `${language.LC().I_WANT_MORE_DETAILS}`,
      });
    }
  };

  //Function to redirect page on specifc questions
  _beginNotes = async (reading, e) => {
    // console.log(reading)
    var reading_id = '';
    var chapter_id = '';
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading.question_id,
    };
    // console.log(data)
    await FD.callAPI(App_data.backend_api + '/frm_notes/getNotesByID', data).then((resp) => {
      if (resp.success) {
        // console.log(resp)
        // console.log(resp.notes)
        chapter_id = resp.notes[0].chapter_id;
        reading_id = resp.notes[0].reading_id;
        // console.log(chapter_id)
        // console.log(reading_id)
        this.context.router.push({
          pathname:
            '/frm/beginnotes/' +
            chapter_id +
            '/' +
            reading_id +
            '/' +
            reading.question_id +
            '/' +
            0,
          state: {
            token: this.state.token,
            idname: this.state.idname,
            reading: reading_id,
            chapter: chapter_id,
            offset: 0,
          },
        });
      }
    });
  };

  //Function to redirect page on specifc questions
  _beginNotes1 = async (reading, e) => {
    // console.log(reading)
    var reading_id = '';
    var chapter_id = '';
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading.question_id,
    };
    // console.log(data)
    await FD.callAPI(App_data.backend_api + '/frm_notes/getNotesByID', data).then((resp) => {
      if (resp.success) {
        // console.log(resp)
        // console.log(resp.notes)
        chapter_id = resp.notes[0].chapter_id;
        reading_id = resp.notes[0].reading_id;
        // console.log(chapter_id)
        // console.log(reading_id)
        this.context.router.push({
          pathname:
            '/frm/beginnotes/' +
            chapter_id +
            '/' +
            reading_id +
            '/' +
            reading.question_id +
            '/' +
            0,
          state: {
            token: this.state.token,
            idname: this.state.idname,
            reading: reading_id,
            chapter: chapter_id,
            offset: 0,
          },
        });
      }
    });
  };
  beginVideos = async (reading, level) => {
    const { token, idname, showCapsules, showFreePremium } = this.state;

    const payload = {
      token,
      idname,
      id: reading.video_id,
    };

    const response = await FD.callAPI(
      `${App_data.backend_api}/frm_question_bank/getVideoByID`,
      payload,
    );

    if (response.success) {
      const video = response.video;
      const isMock = !!video.mock_id;

      const playlistPath = isMock
        ? AppRoutes.FRM_V2_VIDEOS_MOCK_PLAYLIST.replace(':level', level)
            .replace(':mockId', video.mock_id)
            .replace(':id', video.id)
        : AppRoutes.FRM_V2_VIDEOS_PLAYLIST.replace(':level', level)
            .replace(':chapterId', video.chapter_id)
            .replace(':id', video.id);

      this.context.router.push({
        pathname: playlistPath,
        search: `?showCapsules=${showCapsules}&level=${level}`,
      });
    }
  };

  FRM1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 1,
    };
    await FD.callAPI(App_data.backend_api + '/user/authtoken', data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getChapters', data).then((resp) => {
      if (resp.success) {
        var chapters_1_arr = [];
        var first_incr = 0;
        for (var i = 0; i < resp.chapters.length; i++) {
          // eslint-disable-next-line
          if (resp.chapters[i].level == 1) {
            chapters_1_arr[first_incr] = resp.chapters[i];
            first_incr++;
          }
        }
        this.setState({
          chapters: chapters_1_arr,
          bar_chapter: chapters_1_arr,
        });
        // this.setState({progress_bar_zero:chapters_1_arr});
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
    await FD.callAPI(App_data.backend_api + '/frm_dashboard/mainProgressbar', data).then((resp) => {
      if (resp.success) {
        var dataString = JSON.stringify(resp.chapters);
        var dataReason = JSON.parse(dataString);

        var final_array_main = [];

        for (i = 0; i < dataReason.length; i++) {
          var right_answered = dataReason[i].answered_count;
          //var total_question=dataReason[i].question_stat_count;
          var total_question = dataReason[i].attempted_count;

          var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

          if (user_graph_val === 'NaN') {
            final_array_main.push('0.0');
          } else {
            final_array_main.push(user_graph_val);
          }

          //console.log(final_array_main+'----fdg-------');
        }
        this.setState({ bar_main_user: final_array_main });
        //console.log('***********'+this.state.bar_main_user+'++++++++++++');
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
    this.setState({ display_main_loader: 'show_block' });

    await FD.callAPI(App_data.backend_api + '/frm_dashboard/mainProgressclassbar', data).then(
      (resp) => {
        if (resp.success) {
          var dataString = JSON.stringify(resp.chaptersclass);
          var dataReason = JSON.parse(dataString);

          var final_array_main = [];

          for (i = 0; i < dataReason.length; i++) {
            var right_answered = dataReason[i].answered_count;
            var total_question = dataReason[i].attempted_count;

            var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

            if (user_graph_val === 'NaN') {
              final_array_main.push('0.0');
            } else {
              final_array_main.push(user_graph_val);
            }
          }
          this.setState({ bar_main_class: final_array_main });
          //setTimeout(this.setState({display_loader: 'hide_block'}), 5000);
          this.setState({ display_main_loader: 'hide_block' });
          //console.log('***********'+this.state.bar_main_class+'++++++++++++');
        } else {
          console.log(resp.success + '------------failure');
        }
      },
    );

    await FD.callAPI(App_data.backend_api + '/frm_dashboard/getQuestionProgByUser', data).then(
      (resp) => {
        if (resp.success) {
          var chapters_1_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.progressbarzero_data.length; i++) {
            // eslint-disable-next-line
            if (resp.progressbarzero_data[i].level == 1) {
              chapters_1_arr[first_incr] = resp.progressbarzero_data[i];
              first_incr++;
            }
          }
          this.setState({ progress_bar_zero: chapters_1_arr, qpLoader: false });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
    await FD.callAPI(App_data.backend_api + '/frm_dashboard/getnotesprogByuser', data).then(
      (resp) => {
        if (resp.success) {
          var notes_1_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.progressbar_data.length; i++) {
            // eslint-disable-next-line
            if (resp.progressbar_data[i].level == 1) {
              notes_1_arr[first_incr] = resp.progressbar_data[i];
              first_incr++;
            }
          }

          this.setState({ progress_bar: notes_1_arr, npLoader: false });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );

    await this.getQuestionFlashcards();
    await this.getNotesFlashcards();
    await this.getVideoFlashcards();

    await this.getQuestionSaved();
    await this.getNotesSaved();
    await this.getVideosSaved();

    await this.getCBTQestionReports();

    await this.getQuestionReports();
    await this.getNotesReports();
    await this.getVideoReports();
  };
  // function for get  question report
  getQuestionReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/getReportsQuestionsbyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        var reports_arr = [];
        var first_incr = 0;
        for (var i = 0; i < resp.questions.length; i++) {
          if (resp.questions[i].chapter_id <= 4) {
            reports_arr[first_incr] = resp.questions[i];
            first_incr++;
          }
        }
        this.setState({ reportquestion: reports_arr });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  // function to get cbt question reports
  getCBTQestionReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 1,
    };
    await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getreportedQuestion', data).then(
      async (resp) => {
        //console.log('344444444444', resp);
        if (resp.success) {
          this.setState({
            reportquestionCBT: resp.questions,
            reportLoader: false,
          });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };
  // function for get  question FlashCard
  getQuestionFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getFlashcardsbyuserid', data).then(
      (resp) => {
        if (resp.success) {
          var flash_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.flash_report.length; i++) {
            // eslint-disable-next-line
            if (resp.flash_report[i].level == 1) {
              flash_arr[first_incr] = resp.flash_report[i];
              first_incr++;
            }
          }
          this.setState({ flashreport: flash_arr, flashLoader: false });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };
  // function for get  question report
  getQuestionSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/getFavQuestionsbyuserid',
      data,
    ).then((resp) => {
      if (resp.success) {
        var fav_arr = [];
        var first_incr = 0;
        for (var i = 0; i < resp.questions.length; i++) {
          // eslint-disable-next-line
          if (resp.questions[i].level == 1) {
            fav_arr[first_incr] = resp.questions[i];
            first_incr++;
          }
        }
        this.setState({ savedquestion: fav_arr, savedLoader: false });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  // function for get  notes FlashCard
  getNotesFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/frm_notes/getFlashcardsnotesbyuseridD1', data).then(
      async (resp) => {
        if (resp.success) {
          var fav_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.flash_cards.length; i++) {
            if (resp.flash_cards.length > 0) {
              fav_arr[first_incr] = resp.flash_cards[i];
              first_incr++;
            }
          }
          this.setState({ notesFlashReport: fav_arr });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  notes report
  getNotesReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/frm_notes/getReportsNotesbyuserid1', data).then(
      async (resp) => {
        if (resp.success) {
          var fav_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.notes.length; i++) {
            if (resp.notes.length > 0) {
              fav_arr[first_incr] = resp.notes[i];
              first_incr++;
            }
          }
          this.setState({ reportnotes: resp.notes });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };
  // function for get  video report
  getVideoReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    // frm1
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 1,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/getReportsVideobyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({ reportsvideo: resp.video });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  // function for get  video report of frm2
  getVideoReports1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 2,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/getReportsVideobyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({ reportsvideo1: resp.video });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  // function for get  Video falshCard
  getVideoFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 1,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/getFlashcardsVideobyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({ videoFlashReport: resp.flash_report });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  // function for get  Video falshCard
  getVideoFlashcards1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 2,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/getFlashcardsVideobyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({ videoFlashReport1: resp.flash_report });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  getNotesSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };

    await FD.callAPI(App_data.backend_api + '/frm_notes/getFavNotesbyuserID1', data).then(
      (resp) => {
        if (resp.success) {
          var save_1_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.frm_fav_notes.length; i++) {
            if (resp.frm_fav_notes.length > 0) {
              save_1_arr[first_incr] = resp.frm_fav_notes[i];
              first_incr++;
            }
          }
          this.setState({
            savednotes: save_1_arr,
          });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  getVideosSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 2,
    };

    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getFavVideosbyuserID1', data).then(
      (resp) => {
        if (resp.success) {
          var save_1_arr = [];
          var first_incr = 0;

          for (var i = 0; i < resp.frm_fav_videos.length; i++) {
            if (resp.frm_fav_videos.length > 0) {
              save_1_arr[first_incr] = resp.frm_fav_videos[i];
              first_incr++;
            }
          }
          this.setState({
            savedvideo: save_1_arr,
          });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  getVideosSaved1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 2,
    };

    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getFavVideosbyuserID2', data).then(
      (resp) => {
        if (resp.success) {
          var save_1_arr = [];
          var first_incr = 0;

          for (var i = 0; i < resp.frm_fav_videos.length; i++) {
            if (resp.frm_fav_videos.length > 0) {
              save_1_arr[first_incr] = resp.frm_fav_videos[i];
              first_incr++;
            }
          }
          this.setState({
            savedvideo1: save_1_arr,
          });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  FRM2 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate1,
      endDate: this.state.send_startDate_second1,
      level: 2,
    };

    await FD.callAPI(App_data.backend_api + '/user/authtoken', data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getChapters', data).then((resp) => {
      if (resp.success) {
        var chapters_1_arr = [];
        var first_incr = 0;
        for (var i = 0; i < resp.chapters.length; i++) {
          // eslint-disable-next-line
          if (resp.chapters[i].level == 2) {
            chapters_1_arr[first_incr] = resp.chapters[i];
            first_incr++;
          }
        }
        this.setState({
          chapters1: chapters_1_arr,
          bar_chapter1: chapters_1_arr,
        });
        // this.setState({progress_bar_zero:chapters_1_arr});
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
    await FD.callAPI(App_data.backend_api + '/frm_dashboard/mainProgressbar', data).then((resp) => {
      if (resp.success) {
        var dataString = JSON.stringify(resp.chapters);
        var dataReason = JSON.parse(dataString);

        var final_array_main = [];

        for (i = 0; i < dataReason.length; i++) {
          var right_answered = dataReason[i].answered_count;
          //var total_question=dataReason[i].question_stat_count;
          var total_question = dataReason[i].attempted_count;

          var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

          if (user_graph_val === 'NaN') {
            final_array_main.push('0.0');
          } else {
            final_array_main.push(user_graph_val);
          }

          //console.log(final_array_main+'----fdg-------');
        }
        //console.log(final_array_main);
        this.setState({ bar_main_user1: final_array_main });
        //console.log('***********'+this.state.bar_main_user+'++++++++++++');
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
    this.setState({ display_main_loader: 'show_block' });

    await FD.callAPI(App_data.backend_api + '/frm_dashboard/mainProgressclassbar', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ display_main_loader: 'hide_block' });
          var dataString = JSON.stringify(resp.chaptersclass);
          var dataReason = JSON.parse(dataString);

          var final_array_main = [];

          for (i = 0; i < dataReason.length; i++) {
            var right_answered = dataReason[i].answered_count;
            var total_question = dataReason[i].attempted_count;

            var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

            if (user_graph_val === 'NaN') {
              final_array_main.push('0.0');
            } else {
              final_array_main.push(user_graph_val);
            }
          }
          this.setState({ bar_main_class1: final_array_main });
          //setTimeout(this.setState({display_loader: 'hide_block'}), 5000);
          //console.log('***********'+this.state.bar_main_class+'++++++++++++');
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
    await FD.callAPI(App_data.backend_api + '/frm_dashboard/getQuestionProgByUser', data).then(
      (resp) => {
        if (resp.success) {
          var chapters_1_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.progressbarzero_data.length; i++) {
            // eslint-disable-next-line
            if (resp.progressbarzero_data[i].level == 2) {
              chapters_1_arr[first_incr] = resp.progressbarzero_data[i];
              first_incr++;
            }
          }
          this.setState({ progress_bar_zero1: chapters_1_arr });
          //console.log(chapters_1_arr);
        } else {
          console.log(resp.success + '------------failure');
        }
      },
    );
    await FD.callAPI(App_data.backend_api + '/frm_dashboard/getnotesprogByuser', data).then(
      (resp) => {
        if (resp.success) {
          var notes_1_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.progressbar_data.length; i++) {
            // eslint-disable-next-line
            if (resp.progressbar_data[i].level == 2) {
              notes_1_arr[first_incr] = resp.progressbar_data[i];
              first_incr++;
            }
          }

          this.setState({ progress_bar1: notes_1_arr });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
    await this.getQuestionFlashcards1();
    await this.getQuestionSaved1();
    await this.getNotesSaved1();
    await this.getVideoFlashcards1();
    await this.getVideosSaved1();
    await this.getCBTQestionReports1();
    await this.getNotesFlashcards1();
    await this.getQuestionReports1();
    await this.getNotesReports1();
    await this.getVideoReports1();
  };

  // function for get  question report
  getQuestionReports1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/getReportsQuestionsbyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        var reports_arr = [];
        var first_incr = 0;
        for (var i = 0; i < resp.questions.length; i++) {
          if (resp.questions[i].chapter_id > 4) {
            reports_arr[first_incr] = resp.questions[i];
            first_incr++;
          }
        }
        this.setState({ reportquestion1: reports_arr });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  getCBTQestionReports1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      level: 2,
    };
    await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getreportedQuestion', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            reportquestionCBT1: resp.questions,
            reportLoader: false,
          });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  question FlashCard
  getQuestionFlashcards1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getFlashcardsbyuserid', data).then(
      (resp) => {
        if (resp.success) {
          var flash_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.flash_report.length; i++) {
            // eslint-disable-next-line
            if (resp.flash_report[i].level == 2) {
              flash_arr[first_incr] = resp.flash_report[i];
              first_incr++;
            }
          }
          this.setState({ flashreport1: flash_arr, flashLoader: false });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  question report
  getQuestionSaved1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/getFavQuestionsbyuserid',
      data,
    ).then((resp) => {
      if (resp.success) {
        var fav_arr = [];
        var first_incr = 0;
        for (var i = 0; i < resp.questions.length; i++) {
          // eslint-disable-next-line
          if (resp.questions[i].level == 2) {
            fav_arr[first_incr] = resp.questions[i];
            first_incr++;
          }
        }
        this.setState({ savedquestion1: fav_arr, savedLoader: false });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  // function for get  notes report
  getNotesReports1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/frm_notes/getReportsNotesbyuserid2', data).then(
      async (resp) => {
        if (resp.success) {
          var fav_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.notes.length; i++) {
            if (resp.notes.length > 0) {
              fav_arr[first_incr] = resp.notes[i];
              first_incr++;
            }
          }
          this.setState({ reportnotes1: resp.notes });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  notes FlashCard
  getNotesFlashcards1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/frm_notes/getFlashcardsnotesbyuseridD2', data).then(
      async (resp) => {
        if (resp.success) {
          var fav_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.flash_cards.length; i++) {
            if (resp.flash_cards.length > 0) {
              fav_arr[first_incr] = resp.flash_cards[i];
              first_incr++;
            }
          }
          this.setState({ notesFlashReport1: fav_arr });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  getNotesSaved1 = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/frm_notes/getFavNotesbyuserID2', data).then(
      (resp) => {
        if (resp.success) {
          var save_1_arr = [];
          var first_incr = 0;
          for (var i = 0; i < resp.frm_fav_notes.length; i++) {
            if (resp.frm_fav_notes.length > 0) {
              save_1_arr[first_incr] = resp.frm_fav_notes[i];
              first_incr++;
            }
          }
          this.setState({
            savednotes1: save_1_arr,
          });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  async componentDidMount() {
    console.log('I am inside did mount');

    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    // eslint-disable-next-line
    if (localStorage.getItem('selectedmenu') == 'cfa') {
      this.context.router.push({
        pathname: '/dashboard/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async (resp) => {
    this.dispose = autorun(async () => {
      const resp = UserStore;
      if(resp == null || resp.profileInfo == null){
        return;
      }
      var exam_selected = resp.profileInfo.exam_selected
        ? JSON.parse(resp.profileInfo.exam_selected)
        : resp.profileInfo.exam_selected;
      var subscription_details = resp.profileInfo.subscription_details
        ? JSON.parse(resp.profileInfo.subscription_details)
        : resp.profileInfo.subscription_details;
      this.setState({ subscription_details: subscription_details });
      if (resp.profileInfo) {
        this.setState({
          isVideo: resp.profileInfo.isVideo,
        });
      }
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true, showFreePremium1: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async (resp_exam) => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  1,
                  exam_data,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }

                var isInArray_var1 = false;
                isInArray_var1 = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  2,
                  exam_data,
                  examPlanData,
                );
                if (isInArray_var1) {
                  this.setState({ showFreePremium1: false });
                } else {
                  this.setState({ showFreePremium1: true });
                }

                if (isInArray_var || isInArray_var1) {
                  this.setState({
                    showCapsules: false,
                  });
                } else {
                  this.setState({
                    showCapsules: true,
                  });
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this.setState({ showFreePremium: true, showFreePremium1: true });
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async (resp_exam) => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(1, exam_data);
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }

                var isInArray_var1 = false;
                isInArray_var1 = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  2,
                  exam_data,
                );
                if (isInArray_var1) {
                  this.setState({ showFreePremium1: false });
                } else {
                  this.setState({ showFreePremium1: true });
                }

                if (isInArray_var || isInArray_var1) {
                  this.setState({
                    showCapsules: false,
                  });
                } else {
                  this.setState({
                    showCapsules: true,
                  });
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      }
    });

    this.FRM1();
    this.FRM2();
  }

  componentWillUnmount() {
    if (this.dispose) this.dispose();
  }

  _beginChapter = async (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.question_id,
    };
    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getQuestionsbyid', data).then(
      (resp) => {
        if (resp.success) {
          this.context.router.push({
            pathname:
              '/frm/chapter/' +
              resp.questionsbyid.chapter_id +
              '/' +
              resp.questionsbyid.reading_id +
              '/' +
              item.question_id +
              '/' +
              1,
            state: {
              token: this.state.token,
              idname: this.state.idname,
              reading: resp.questionsbyid.reading_id,
              chapter: resp.questionsbyid.chapter_id,
              selectedMenu: this.state.selectedmenufrm,
            },
          });
        } else {
          //console.log('Not Found');
        }
      },
    );
  };

  _beginChapter1 = async (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.question_id,
    };
    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getQuestionsbyid', data).then(
      (resp) => {
        if (resp.success) {
          this.context.router.push({
            pathname:
              '/frm/chapter/' +
              resp.questionsbyid.chapter_id +
              '/' +
              resp.questionsbyid.reading_id +
              '/' +
              item.question_id +
              '/' +
              2,
            state: {
              token: this.state.token,
              idname: this.state.idname,
              reading: resp.questionsbyid.reading_id,
              chapter: resp.questionsbyid.chapter_id,
              selectedMenu: this.state.selectedmenufrm,
            },
          });
        } else {
          //console.log('Not Found');
        }
      },
    );
  };
  questionProgressBarFun() {
    return this.state.progress_bar_zero.map((item, index) => {
      var progressnotes_zero = Math.round((item.counttotquestion / item.question_stat_count) * 100);
      if (progressnotes_zero < 1) {
        progressnotes_zero = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>Q.{index + 1}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes_zero}
                      style={{ width: progressnotes_zero + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }

  questionProgressBarFun1() {
    return this.state.progress_bar_zero1.map((item, index) => {
      var progressnotes_zero = Math.round((item.counttotquestion / item.question_stat_count) * 100);
      if (progressnotes_zero < 1) {
        progressnotes_zero = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>Q.{index + 1}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes_zero}
                      style={{ width: progressnotes_zero + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }
  notesProgressBarFun() {
    return this.state.progress_bar.map((item, index) => {
      var progresstotalques = item.chapterallqurestion;
      var progressnotes = Math.round((item.fav / progresstotalques) * 100);
      if (progressnotes < 1) {
        progressnotes = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>N.{index + 1}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes}
                      style={{ width: progressnotes + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }

  notesProgressBarFun1() {
    return this.state.progress_bar1.map((item, index) => {
      var progresstotalques = item.chapterallqurestion;
      var progressnotes = Math.round((item.fav / progresstotalques) * 100);
      if (progressnotes < 1) {
        progressnotes = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>N.{index + 1}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes}
                      style={{ width: progressnotes + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }

  // question form submit function
  async handleQuestionReportSubmit(event) {
    event.preventDefault();
    if (this.state.quesReport === '' && this.state.quesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, quesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      quesReport: quesReport,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/UpdateReportsQuestionsbyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          quesReport: '',
        });
        await this.getQuestionReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  // question form submit function
  async handleQuestionReportSubmit1(event) {
    event.preventDefault();
    if (this.state.quesReport1 === '' && this.state.quesReport1.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage1: "Report can't be empty",
      });
      return;
    }
    const { reportEditId1, idname, token, quesReport1 } = this.state;
    const data = {
      id: reportEditId1,
      idname: idname,
      token: token,
      quesReport: quesReport1,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/UpdateReportsQuestionsbyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus1: !this.state.reportEditStatus1,
          reportEditId1: '',
          quesReport1: '',
        });
        await this.getQuestionReports1();
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  // question form submit function
  async handleCBTQuestionReportSubmit(event) {
    event.preventDefault();
    if (this.state.cbtquesReport === '' && this.state.cbtquesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, cbtquesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      quesReport: cbtquesReport,
      level: 1,
    };
    await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/updateReport', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId: '',
            cbtquesReport: '',
          });
          await this.getCBTQestionReports();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  // question form submit function
  async handleCBTQuestionReportSubmit1(event) {
    event.preventDefault();
    if (this.state.cbtquesReport1 === '' && this.state.cbtquesReport1.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage1: "Report can't be empty",
      });
      return;
    }
    const { reportEditId1, idname, token, cbtquesReport1 } = this.state;
    const data = {
      id: reportEditId1,
      idname: idname,
      token: token,
      quesReport: cbtquesReport1,
      level: 2,
    };
    await FD.callAPI(App_data.backend_api + '/frmCBTMockExams/updateReport', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId1: '',
            cbtquesReport1: '',
          });
          await this.getCBTQestionReports1();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  // notes form submit function
  async handleNotesReportSubmit(event) {
    event.preventDefault();
    if (this.state.notesReport === '' && this.state.notesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, notesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      notesReport: notesReport,
    };
    await FD.callAPI(App_data.backend_api + '/frm_notes/UpdateReportsNotesbyuserid', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId: '',
            notesReport: '',
          });
          await this.getNotesReports();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  // notes form submit function
  async handleNotesReportSubmit1(event) {
    event.preventDefault();
    if (this.state.notesReport1 === '' && this.state.notesReport1.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage1: "Report can't be empty",
      });
      return;
    }
    const { reportEditId1, idname, token, notesReport1 } = this.state;
    const data = {
      id: reportEditId1,
      idname: idname,
      token: token,
      notesReport: notesReport1,
    };
    await FD.callAPI(App_data.backend_api + '/frm_notes/UpdateReportsNotesbyuserid', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus1: !this.state.reportEditStatus1,
            reportEditId1: '',
            notesReport1: '',
          });
          await this.getNotesReports1();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  // video form submit function
  handleVideoReportSubmit = async (event) => {
    event.preventDefault();
    if (this.state.videoReport === '' && this.state.videoReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, videoReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      videoReport: videoReport,
      level: 1,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/UpdateReportsVideobyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          videoReport: '',
        });
        await this.getVideoReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  // video form submit function
  handleVideoReportSubmit1 = async (event) => {
    //console.log('inside submiyyyyyttttttttttttttttttttt', event);
    //console.log('');
    event.preventDefault();
    if (this.state.videoReport1 === '' && this.state.videoReport1.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage1: "Report can't be empty",
      });
      return;
    }
    const { reportEditId1, idname, token, videoReport1 } = this.state;
    const data = {
      id: reportEditId1,
      idname: idname,
      token: token,
      videoReport: videoReport1,
      level: 2,
    };
    await FD.callAPI(
      App_data.backend_api + '/frm_question_bank/UpdateReportsVideobyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus1: !this.state.reportEditStatus1,
          reportEditId: '',
          videoReport1: '',
        });
        await this.getVideoReports1();
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  // function for state change of edit report form fileds
  InputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      ErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  SubjectInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      SubjectErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  CommentInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      CommentErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  InputChange1(e) {
    //console.log('callling-------', e.target.name);
    //console.log('fffffffffffff', e.target.value);

    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      ErrorMessage1: '',
    });
  }

  // function for state change of edit report form fileds
  SubjectInputChange1(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      SubjectErrorMessage1: '',
    });
  }

  // function for state change of edit report form fileds
  CommentInputChange1(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      CommentErrorMessage1: '',
    });
  }

  flashcardTabToggle = (tab) => {
    if (this.state.activeTabFlashcards !== tab) {
      this.setState({
        activeTabFlashcards: tab,
      });
    }
  };

  savedTabToggle = (tab) => {
    if (this.state.activeTabSaved !== tab) {
      this.setState({
        activeTabSaved: tab,
      });
    }
  };

  reportsTabToggle = (tab) => {
    if (this.state.activeTabReports !== tab) {
      this.setState({
        activeTabReports: tab,
      });
    }
  };

  flashcardTabToggle1 = (tab) => {
    if (this.state.activeTabFlashcards1 !== tab) {
      this.setState({
        activeTabFlashcards1: tab,
      });
    }
  };

  savedTabToggle1 = (tab) => {
    if (this.state.activeTabSaved1 !== tab) {
      this.setState({
        activeTabSaved1: tab,
      });
    }
  };

  reportsTabToggle1 = (tab) => {
    if (this.state.activeTabReports1 !== tab) {
      this.setState({
        activeTabReports1: tab,
      });
    }
  };

  // function to view cbt question
  view = (item) => {
    if (item.mockData) {
      let mock = JSON.parse(item.mockData);
      this.context.router.push({
        pathname: `/frm/cbtquestionsfinish/${mock.mock_id}/${item.question_id}/${mock.timer}/1/${
          mock.test_id
        }/${mock.offset}`,
      });
    }
  };
  // function to view cbt question
  view1 = (item) => {
    if (item.mockData) {
      let mock = JSON.parse(item.mockData);
      this.context.router.push({
        pathname: `/frm/cbtquestionsfinish/${mock.mock_id}/${item.question_id}/${mock.timer}/2/${
          mock.test_id
        }/${mock.offset}`,
      });
    }
  };
  render() {
    const {
      activeTabFlashcards,
      activeTabSaved,
      activeTabReports,
      activeTabFlashcards1,
      activeTabSaved1,
      activeTabReports1,
      qpLoader,
      npLoader,
      savedLoader,
      flashLoader,
      reportLoader,
    } = this.state;
    let flashreport_val = this.state.flashreport;
    let flashreport_val1 = this.state.flashreport1;

    let notes_flashreport_val = this.state.notesFlashReport;
    let notes_flashreport_val1 = this.state.notesFlashReport1;

    let video_flashreport_val = this.state.videoFlashReport;
    let video_flashreport_val1 = this.state.videoFlashReport1;

    let savedquestion_val = this.state.savedquestion;
    let savedquestion_val1 = this.state.savedquestion1;

    let savednotes_val = this.state.savednotes;
    let savednotes_val1 = this.state.savednotes1;

    let savedvideo_val = this.state.savedvideo;
    let savedvideo_val1 = this.state.savedvideo1;

    // let progress_bar_zero_val = this.state.progress_bar_zero;
    // let progress_bar_zero_val1 = this.state.progress_bar_zero1;

    // let progress_barnotes_val = this.state.progress_bar;
    // let progress_barnotes_val1 = this.state.progress_bar1;

    let reportquestion_val = this.state.reportquestion;
    let reportquestion_val1 = this.state.reportquestion1;

    let reportquestionCBT_val = this.state.reportquestionCBT;
    let reportquestionCBT_val1 = this.state.reportquestionCBT1;

    let reportnotes_val = this.state.reportnotes;
    let reportnotes_val1 = this.state.reportnotes1;

    let reportvideo_val = this.state.reportsvideo;
    let reportvideo_val1 = this.state.reportsvideo1;

    let question_reportsData = ''; // for question reports
    let question_reportsData1 = ''; // for question reports

    let cbt_reportsData = ''; // for cbt question reports
    let cbt_reportsData1 = ''; // for cbt question reports

    let notes_reportsData = ''; // for notes report
    let notes_reportsData1 = ''; // for notes1 report

    let video_reportsData = ''; // for video report
    let video_reportsData1 = ''; // for video report

    let flashcard_data = '';
    let flashcard_data1 = '';

    let notes_flashcard_data = '';
    let notes_flashcard_data1 = '';

    let video_flashcard_data = '';
    let video_flashcard_data1 = '';

    let savedquestion_data = '';
    let savednotes_data = '';
    let savedvideos_data = '';
    let savedvideos_data1 = '';

    // let progress_bar_data = "";
    // let progress_bar_data1 = "";

    let savedquestion_data1 = '';
    let savednotes_data1 = '';

    /*first main graph*/
    let main_bar_val = this.state.bar_chapter;
    let main_bar_val1 = this.state.bar_chapter1;

    let main_bar_percentage = this.state.bar_main_user;
    let main_bar_percentage1 = this.state.bar_main_user1;
    let main_bar_user_percentage = this.state.bar_main_class;
    let main_bar_user_percentage1 = this.state.bar_main_class1;

    //console.log(main_bar_user_percentage+'sdfdsfdsf');
    let main_bar_data = [];
    let main_bar_data1 = [];

    var i = 0;

    // eslint-disable-next-line
    Object.keys(main_bar_val).map(function (key) {
      var dataString = JSON.stringify(main_bar_val[key]);
      var dataReason = JSON.parse(dataString);
      main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
      // var chapter_id = dataReason.chapter_id;

      i++;
    });
    var i1 = 0;

    // eslint-disable-next-line
    Object.keys(main_bar_val1).map(function (key) {
      var dataString1 = JSON.stringify(main_bar_val1[key]);
      var dataReason1 = JSON.parse(dataString1);
      main_bar_data1[i1] = dataReason1.chapter_name.substring(0, 14);
      // var chapter_id1 = dataReason1.chapter_id;

      i1++;
    });

    var bar_data = {
      labels: main_bar_data,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: main_bar_percentage,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: main_bar_user_percentage,
        },
      ],
    };

    var bar_data1 = {
      labels: main_bar_data1,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: main_bar_percentage1,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: main_bar_user_percentage1,
        },
      ],
    };

    /*other graph*/
    let chapters = this.state.chapters;
    let chapters1 = this.state.chapters1;

    // eslint-disable-next-line
    let reading_data = '';
    // eslint-disable-next-line
    let reading_data1 = '';

    // alert(this.state.subreadings_status);
    if (this.state.chapters.length && !this.state.subreadings_status) {
      reading_data = chapters.map((item, index) => (
        <div className='card' key={index}>
          <div className='card-header' key={item.id} value={item.id}>
            <a className='pointer_class' id={item.chapter_name} value={item.id}>
              {item.chapter_name}
            </a>
          </div>
          <div className='card-block' key={item.chapter_name} id={'bar_sub_item' + index}>
            {/* <Barget chapter_id={item.chapter_no}  idname={this.state.idname} token={this.state.token} answered_state={index} />*/}
          </div>
        </div>
      ));
    }
    if (this.state.chapters1.length && !this.state.subreadings_status1) {
      reading_data1 = chapters1.map((item, index) => (
        <div className='card' key={index}>
          <div className='card-header' key={item.id} value={item.id}>
            <a className='pointer_class' id={item.chapter_name} value={item.id}>
              {item.chapter_name}
            </a>
          </div>
          <div className='card-block' key={item.chapter_name} id={'bar_sub_item1' + index}>
            <Barget
              chapter_id={item.chapter_no}
              idname={this.state.idname}
              token={this.state.token}
              answered_state={index}
            />
          </div>
        </div>
      ));
    }

    if (this.state.chapters.length && this.state.subreadings_status) {
      reading_data = chapters.map((item, index) => (
        <div className='col-sm-12' key={index}>
          <div className='card ' key={item.id}>
            <div className='card-header' key={item.id} value={item.id}>
              <a className='pointer_class' id={item.chapter_name} value={item.id}>
                {item.chapter_name}
              </a>
            </div>
            <div className='card-block' key={item.chapter_name} id={'bar_sub_item' + index}>
              {/*<Barget chapter_id={item.chapter_no}  idname={this.state.idname} token={this.state.token} answered_state={index} startDate={this.state.send_startDate} endDate={this.state.send_startDate_second} subreadings_status={this.state.subreadings_status}/>*/}
            </div>
          </div>
        </div>
      ));
    }
    if (this.state.chapters1.length && this.state.subreadings_status1) {
      reading_data1 = chapters1.map((item, index) => (
        <div className='col-sm-12' key={index}>
          <div className='card ' key={item.id}>
            <div className='card-header' key={item.id} value={item.id}>
              <a className='pointer_class' id={item.chapter_name} value={item.id}>
                {item.chapter_name}
              </a>
            </div>
            <div className='card-block' key={item.chapter_name} id={'bar_sub_item1' + index}>
              <Barget
                chapter_id={item.chapter_no}
                idname={this.state.idname}
                token={this.state.token}
                answered_state={index}
                startDate={this.state.send_startDate1}
                endDate={this.state.send_startDate_second1}
                subreadings_status={this.state.subreadings_status1}
              />
            </div>
          </div>
        </div>
      ));
    }

    if (this.state.notesFlashReport.length) {
      notes_flashcard_data = notes_flashreport_val.map((items, index) => (
        <div id={'notesFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteNotesFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else {
      notes_flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.notesFlashReport1.length) {
      notes_flashcard_data1 = notes_flashreport_val1.map((items, index) => (
        <div id={'notesFlash__' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes1.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteNotesFlashcard1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else {
      notes_flashcard_data1 = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.flashreport.length) {
      flashcard_data = flashreport_val.map((items, index) => (
        <div id={'flash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}:</strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
           <button className="btn btn-primary" onClick={this._deleteFlashcard.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else if (flashLoader) {
      flashcard_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.flashreport1.length) {
      flashcard_data1 = flashreport_val1.map((items, index) => (
        <div id={'flash__' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}:</strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter1.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteFlashcard1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
           <button className="btn btn-primary" onClick={this._deleteFlashcard.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else if (flashLoader) {
      flashcard_data1 = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      flashcard_data1 = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.videoFlashReport.length) {
      video_flashcard_data = video_flashreport_val.map((items, index) => (
        <div id={'videoFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={() => this.beginVideos(items, 1)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteVideoFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else {
      video_flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.videoFlashReport1.length) {
      video_flashcard_data1 = video_flashreport_val1.map((items, index) => (
        <div id={'videoFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this.beginVideos.bind(this, items, 2)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteVideoFlashcard1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else {
      video_flashcard_data1 = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.savedquestion.length) {
      savedquestion_data = savedquestion_val.map((items, index) => (
        <div id={'savedque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSavequestion.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
           <button className="btn btn-primary" onClick={this._deleteSavequestion.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else if (savedLoader) {
      savedquestion_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      savedquestion_data = <div className='text-center'>{language.LC().NO_SAVED_QUESTIONS}</div>;
    }

    if (this.state.savednotes.length) {
      savednotes_data = savednotes_val.map((items, index) => (
        <div id={'savednotes_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSavedNotes.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
           <button className="btn btn-primary" onClick={this._deleteSavequestion.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else {
      savednotes_data = <div className='text-center'>{language.LC().NO_SAVED_NOTES}</div>;
    }

    if (this.state.savedvideo.length) {
      savedvideos_data = savedvideo_val.map((items, index) => (
        <div id={'savedvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={() => this.beginVideos(items, 1)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deletesavedvideo.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
           <button className="btn btn-primary" onClick={this._deleteSavequestion.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else {
      savedvideos_data = <div className='text-center'>{language.LC().NO_SAVED_VIDEO}</div>;
    }

    if (this.state.savedvideo1.length) {
      savedvideos_data1 = savedvideo_val1.map((items, index) => (
        <div id={'savedvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this.beginVideos.bind(this, items, 2)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deletesavedvideo1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
           <button className="btn btn-primary" onClick={this._deleteSavequestion.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else {
      savedvideos_data1 = <div className='text-center'>{language.LC().NO_SAVED_VIDEO}</div>;
    }

    if (this.state.savedquestion1.length) {
      savedquestion_data1 = savedquestion_val1.map((items, index) => (
        <div id={'savedque__' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter1.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSavequestion1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
           <button className="btn btn-primary" onClick={this._deleteSavequestion.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else if (savedLoader) {
      savedquestion_data1 = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      savedquestion_data1 = <div className='text-center'>{language.LC().NO_SAVED_QUESTIONS}</div>;
    }

    if (this.state.savednotes1.length) {
      savednotes_data1 = savednotes_val1.map((items, index) => (
        <div id={'savednotes1_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes1.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSavedNotes1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
           <button className="btn btn-primary" onClick={this._deleteSavequestion.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else {
      savednotes_data1 = <div className='text-center'>{language.LC().NO_SAVED_NOTES}</div>;
    }

    if (this.state.reportquestion.length) {
      question_reportsData = reportquestion_val.map((items, index) => (
        <div id={'reportsque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditQuesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'quesReport'
              }
              toggle={this.OpenEditQuesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditQuesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleQuestionReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='quesReportcomment'
                          name='quesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.quesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditQuesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'quesReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'quesReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactType === 'quesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'quesReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'quesReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactType === 'quesReport' &&
                this.state.contactID === items.id &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsquestino.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else if (reportLoader) {
      question_reportsData = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      question_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportquestion1.length) {
      question_reportsData1 = reportquestion_val1.map((items, index) => (
        <div id={'reportsque1_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>

            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditQuesReport1.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus1 &&
                this.state.reportEditId1 === items.id &&
                this.state.type1 === 'quesReport1'
              }
              toggle={this.OpenEditQuesReport1}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditQuesReport1}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleQuestionReportSubmit1.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='quesReportcomment1'
                          name='quesReport1'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange1.bind(this)}
                          value={this.state.quesReport1}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage1}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditQuesReport1}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter1.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport1.bind(this, items, 'quesReport1')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus1 &&
                this.state.reportAnswerId1 === items.id &&
                this.state.type1 === 'quesReport1'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus1 &&
                  this.state.contactType1 === 'quesReport1' &&
                  this.state.contactID1 === items.id &&
                  this.state.contactIndex1 === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange1.bind(this, items, index, 'quesReport1')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange1.bind(this, items, index, 'quesReport1')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport1}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus1 &&
                this.state.contactType1 === 'quesReport1' &&
                this.state.contactID1 === items.id &&
                this.state.contactIndex1 === index ? (
                  !this.state.successAlert1 ? (
                    <form onSubmit={this.onContactSubmit1.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject1'
                            name='contactSubject1'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange1.bind(this)}
                            value={this.state.contactSubject1}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage1}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment1'
                            name='contactComment1'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange1.bind(this)}
                            value={this.state.contactComment1}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage1}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose1}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsquestino1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else if (reportLoader) {
      question_reportsData1 = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      question_reportsData1 = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportquestionCBT.length) {
      cbt_reportsData = reportquestionCBT_val.map((items, index) => {
        let parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
        let mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
        return (
          <div id={'reportsque_' + items.id} key={index} className='flash_card_box'>
            <div>
              <span>
                <strong> {language.LC().TICKET_ID}: </strong> {items.id}
              </span>

              <span
                className={`float-right status-${
                  items.status === 'resolved' ? 'resolved' : 'pending'
                }`}
              >
                <strong className='text-capitalize'>
                  {items.status === 'resolved' ? 'resolved' : 'pending'}
                </strong>
              </span>
            </div>

            <div className='mt-1'>
              <span>
                <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
              </span>
              {!items.isSend && !items.answer && items.status !== 'resolved' ? (
                <span
                  className='up tooltip-hover-questions float-right'
                  style={{ padding: '10px' }}
                  onClick={items.isSend ? null : this.OpenEditCBTQuesReport.bind(this, items)}
                  disabled={items.isSend}
                >
                  <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                  <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                    {' '}
                  </i>
                </span>
              ) : null}
              <Modal
                isOpen={
                  this.state.reportEditStatus &&
                  this.state.reportEditId === items.id &&
                  this.state.type === 'cbtquesReport'
                }
                toggle={this.OpenEditCBTQuesReport}
                className={'modal-primary ' + this.props.className}
              >
                <ModalHeader>
                  Q. {items.question_id} {renderHTMLContent(mockName, 'span')}
                  <Button className='close' color='secondary' onClick={this.CloseEditCBTQuesReport}>
                    ×
                  </Button>
                </ModalHeader>
                <ModalBody>
                  <div className='card-block'>
                    <form onSubmit={this.handleCBTQuestionReportSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <textarea
                            id='comment'
                            name='cbtquesReport'
                            rows='6'
                            className='form-control'
                            placeholder='Content..'
                            onChange={this.InputChange.bind(this)}
                            value={this.state.cbtquesReport}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.ErrorMessage}
                          </span>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-12 d-flex'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {language.LC().UPDATE}
                          </button>

                          <button
                            type='button'
                            className='btn btn-danger active pointer_class margin_left_10'
                            onClick={this.CloseEditCBTQuesReport}
                          >
                            {' '}
                            {language.LC().CANCEL}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </ModalBody>
              </Modal>

              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW} </div>
                <i
                  onClick={() => this.view(items)}
                  className={this.state.viewCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>

              {items.isSend && items.reply && items.reply.length > 0 ? (
                <span
                  className='up tooltip-hover-questions float-right'
                  style={{ padding: '10px' }}
                >
                  <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                  <i
                    onClick={this.toggleAlertReport.bind(this, items, 'cbtquesReport')}
                    className={this.state.viewREPORTCSS}
                    style={{ color: '#1f8ceb' }}
                  />
                </span>
              ) : null}
              <Modal
                isOpen={
                  this.state.reportAnswerStatus &&
                  this.state.reportAnswerId === items.id &&
                  this.state.type === 'cbtquesReport'
                }
                toggle={this.toggleAlertReport}
                className={'modal-primary ' + this.props.className}
              >
                <ModalHeader>
                  Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                  <div className='contact-us-btn float-right'>
                    {this.state.contactStatus &&
                    this.state.contactType === 'cbtquesReport' &&
                    this.state.contactID === items.id &&
                    this.state.contactIndex === index ? (
                      <Button
                        className='btn btn-primary'
                        onClick={this.onContactChange.bind(this, items, index, 'cbtquesReport')}
                      >
                        {language.LC().GO_TO_ANSWER}{' '}
                      </Button>
                    ) : (
                      <Button
                        className='btn btn-primary'
                        onClick={this.onContactChange.bind(this, items, index, 'cbtquesReport')}
                      >
                        {' '}
                        <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                        {language.LC().I_need_further_help}{' '}
                      </Button>
                    )}
                    <Button
                      className='close'
                      style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                      color='secondary'
                      onClick={this.toggleCloseReport}
                    >
                      ×
                    </Button>
                  </div>
                </ModalHeader>
                <ModalBody>
                  {this.state.contactStatus &&
                  this.state.contactType === 'cbtquesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    !this.state.successAlert ? (
                      <form onSubmit={this.onContactSubmit.bind(this)}>
                        <div className='row'>
                          <div className='col-sm-12 margin_bottom_10'>
                            <h6 className='mb-1 d-flex'>
                              {' '}
                              {language.LC().SUBJECT}{' '}
                              <span className={this.state.displaytext + ' text-danger'}>*</span>
                            </h6>
                            <textarea
                              id='contactSubject'
                              name='contactSubject'
                              rows='2'
                              className='form-control'
                              placeholder='Subject..'
                              onChange={this.SubjectInputChange.bind(this)}
                              value={this.state.contactSubject}
                            />
                            <span className={this.state.displaytext + ' text-danger'}>
                              {this.state.SubjectErrorMessage}
                            </span>
                          </div>
                          <div className='col-sm-12 margin_bottom_10'>
                            <h6 className='mb-1 d-flex'>
                              {' '}
                              {language.LC().COMMENT}{' '}
                              <span className={this.state.displaytext + ' text-danger'}>*</span>
                            </h6>
                            <textarea
                              id='contactComment'
                              name='contactComment'
                              rows='6'
                              className='form-control'
                              placeholder='Comment..'
                              onChange={this.CommentInputChange.bind(this)}
                              value={this.state.contactComment}
                            />
                            <span className={this.state.displaytext + ' text-danger'}>
                              {this.state.CommentErrorMessage}
                            </span>
                          </div>
                          <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                            <button type='submit' className='btn btn-primary active pointer_class'>
                              {' '}
                              {this.state.isLoading
                                ? 'Please wait ...'
                                : language.LC().SEND_REQUEST}
                            </button>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className='text-center'>
                      <p className='margin_bottom_20'>
                        <span>{renderSanitizedHTML(items.reply)}</span>
                      </p>
                    </div>
                  )}
                </ModalBody>
              </Modal>
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().DELETE} </div>
                <i
                  onClick={this._deleteCBTReportsquestino.bind(this, items)}
                  className={this.state.deleteCSS}
                  style={{ color: '#f51a00' }}
                >
                  {' '}
                </i>
              </span>
            </div>
            <p className='mt-1'>
              <strong> {language.LC().REPORT}: </strong>
              <span>{renderSanitizedHTML(items.comment)}</span>
            </p>
          </div>
        );
      });
    } else {
      cbt_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportquestionCBT1.length) {
      cbt_reportsData1 = reportquestionCBT_val1.map((items, index) => {
        let parsedMockData = items && items.mockData ? JSON.parse(items.mockData) : null;
        let mockName = parsedMockData && parsedMockData.mockName ? parsedMockData.mockName : '';
        return (
          <div id={'reportsque1_' + items.id} key={index} className='flash_card_box'>
            <div>
              <span>
                <strong> {language.LC().TICKET_ID}: </strong> {items.id}
              </span>

              <span
                className={`float-right status-${
                  items.status === 'resolved' ? 'resolved' : 'pending'
                }`}
              >
                <strong className='text-capitalize'>
                  {items.status === 'resolved' ? 'resolved' : 'pending'}
                </strong>
              </span>
            </div>

            <div className='mt-1'>
              <span>
                <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
              </span>

              {!items.isSend && !items.answer && items.status !== 'resolved' ? (
                <span
                  className='up tooltip-hover-questions float-right'
                  style={{ padding: '10px' }}
                  onClick={items.isSend ? null : this.OpenEditCBTQuesReport1.bind(this, items)}
                  disabled={items.isSend}
                >
                  <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                  <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                    {' '}
                  </i>
                </span>
              ) : null}
              <Modal
                isOpen={
                  this.state.reportEditStatus1 &&
                  this.state.reportEditId1 === items.id &&
                  this.state.type1 === 'cbtquesReport1'
                }
                toggle={this.OpenEditCBTQuesReport1}
                className={'modal-primary ' + this.props.className}
              >
                <ModalHeader>
                  Q. {items.question_id} {renderSanitizedHTML(mockName, 'span')}
                  <Button
                    className='close'
                    color='secondary'
                    onClick={this.CloseEditCBTQuesReport1}
                  >
                    ×
                  </Button>
                </ModalHeader>
                <ModalBody>
                  <div className='card-block'>
                    <form onSubmit={this.handleCBTQuestionReportSubmit1.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <textarea
                            id='cbtquesReport1'
                            name='cbtquesReport1'
                            rows='6'
                            className='form-control'
                            placeholder='Content..'
                            onChange={this.InputChange1.bind(this)}
                            value={this.state.cbtquesReport1}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.ErrorMessage1}
                          </span>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-12 d-flex'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {language.LC().UPDATE}
                          </button>

                          <button
                            type='button'
                            className='btn btn-danger active pointer_class margin_left_10'
                            onClick={this.CloseEditCBTQuesReport1}
                          >
                            {' '}
                            {language.LC().CANCEL}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </ModalBody>
              </Modal>

              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW} </div>
                <i
                  onClick={() => this.view1(items)}
                  className={this.state.viewCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>

              {items.isSend && items.reply && items.reply.length > 0 ? (
                <span
                  className='up tooltip-hover-questions float-right'
                  style={{ padding: '10px' }}
                >
                  <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                  <i
                    onClick={this.toggleAlertReport1.bind(this, items, 'cbtquesReport1')}
                    className={this.state.viewREPORTCSS}
                    style={{ color: '#1f8ceb' }}
                  >
                    {' '}
                  </i>
                </span>
              ) : null}
              <Modal
                isOpen={
                  this.state.reportAnswerStatus1 &&
                  this.state.reportAnswerId1 === items.id &&
                  this.state.type1 === 'cbtquesReport1'
                }
                toggle={this.toggleAlertReport}
                className={'modal-primary ' + this.props.className}
              >
                <ModalHeader>
                  Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                  <div className='contact-us-btn float-right'>
                    {this.state.contactStatus1 &&
                    this.state.contactType1 === 'cbtquesReport1' &&
                    this.state.contactID1 === items.id &&
                    this.state.contactIndex1 === index ? (
                      <Button
                        className='btn btn-primary'
                        onClick={this.onContactChange1.bind(this, items, index, 'cbtquesReport1')}
                      >
                        {language.LC().GO_TO_ANSWER}{' '}
                      </Button>
                    ) : (
                      <Button
                        className='btn btn-primary'
                        onClick={this.onContactChange1.bind(this, items, index, 'cbtquesReport1')}
                      >
                        {' '}
                        <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                        {language.LC().I_need_further_help}{' '}
                      </Button>
                    )}
                    <Button
                      className='close'
                      style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                      color='secondary'
                      onClick={this.toggleCloseReport1}
                    >
                      ×
                    </Button>
                  </div>
                </ModalHeader>
                <ModalBody>
                  {this.state.contactStatus1 &&
                  this.state.contactType1 === 'cbtquesReport1' &&
                  this.state.contactID1 === items.id &&
                  this.state.contactIndex1 === index ? (
                    !this.state.successAlert1 ? (
                      <form onSubmit={this.onContactSubmit1.bind(this)}>
                        <div className='row'>
                          <div className='col-sm-12 margin_bottom_10'>
                            <h6 className='mb-1 d-flex'>
                              {' '}
                              {language.LC().SUBJECT}{' '}
                              <span className={this.state.displaytext + ' text-danger'}>*</span>
                            </h6>
                            <textarea
                              id='contactSubject1'
                              name='contactSubject1'
                              rows='2'
                              className='form-control'
                              placeholder='Subject..'
                              onChange={this.SubjectInputChange1.bind(this)}
                              value={this.state.contactSubject1}
                            />
                            <span className={this.state.displaytext + ' text-danger'}>
                              {this.state.SubjectErrorMessage1}
                            </span>
                          </div>
                          <div className='col-sm-12 margin_bottom_10'>
                            <h6 className='mb-1 d-flex'>
                              {' '}
                              {language.LC().COMMENT}{' '}
                              <span className={this.state.displaytext + ' text-danger'}>*</span>
                            </h6>
                            <textarea
                              id='contactComment1'
                              name='contactComment1'
                              rows='6'
                              className='form-control'
                              placeholder='Comment..'
                              onChange={this.CommentInputChange1.bind(this)}
                              value={this.state.contactComment1}
                            />
                            <span className={this.state.displaytext + ' text-danger'}>
                              {this.state.CommentErrorMessage1}
                            </span>
                          </div>
                          <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                            <button type='submit' className='btn btn-primary active pointer_class'>
                              {' '}
                              {this.state.isLoading
                                ? 'Please wait ...'
                                : language.LC().SEND_REQUEST}
                            </button>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose1}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className='text-center'>
                      <p className='margin_bottom_20'>
                        <span>{renderSanitizedHTML(items.reply)}</span>
                      </p>
                    </div>
                  )}
                </ModalBody>
              </Modal>
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().DELETE} </div>
                <i
                  onClick={this._deleteCBTReportsquestino1.bind(this, items)}
                  className={this.state.deleteCSS}
                  style={{ color: '#f51a00' }}
                >
                  {' '}
                </i>
              </span>
            </div>
            <p className='mt-1'>
              <strong> {language.LC().REPORT}: </strong>
              <span>{renderSanitizedHTML(items.comment)}</span>
            </p>
          </div>
        );
      });
    } else {
      cbt_reportsData1 = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportnotes.length) {
      notes_reportsData = reportnotes_val.map((items, index) => (
        <div id={'reportsnotes_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditNotesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'notesReport'
              }
              toggle={this.OpenEditNotesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditNotesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleNotesReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='notesReportComment'
                          name='notesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.notesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditNotesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'notesReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'notesReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactType === 'notesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'notesReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'notesReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactType === 'notesReport' &&
                this.state.contactID === items.id &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsNotes.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else {
      notes_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportnotes1.length) {
      notes_reportsData1 = reportnotes_val1.map((items, index) => (
        <div id={'reportsnotes1_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={
                  items.isSend ? null : this.OpenEditNotesReport1.bind(this, items, 'notesReport1')
                }
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus1 &&
                this.state.reportEditId1 === items.id &&
                this.state.type1 === 'notesReport1'
              }
              toggle={this.OpenEditNotesReport1}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditNotesReport1}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleNotesReportSubmit1.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='notesReportcomment1'
                          name='notesReport1'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange1.bind(this)}
                          value={this.state.notesReport1}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage1}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditNotesReport1}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes1.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport1.bind(this, items, 'notesReport1')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus1 &&
                this.state.reportAnswerId1 === items.id &&
                this.state.type1 === 'notesReport1'
              }
              toggle={this.toggleAlertReport1}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus1 &&
                  this.state.contactType1 === 'notesReport1' &&
                  this.state.contactID1 === items.id &&
                  this.state.contactIndex1 === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange1.bind(this, items, index, 'notesReport1')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange1.bind(this, items, index, 'notesReport1')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport1}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus1 &&
                this.state.contactType1 === 'notesReport1' &&
                this.state.contactID1 === items.id &&
                this.state.contactIndex1 === index ? (
                  !this.state.successAlert1 ? (
                    <form onSubmit={this.onContactSubmit1.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject1'
                            name='contactSubject1'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange1.bind(this)}
                            value={this.state.contactSubject1}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage1}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment1'
                            name='contactComment1'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange1.bind(this)}
                            value={this.state.contactComment1}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage1}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose1}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsNotes1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else {
      notes_reportsData1 = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportsvideo.length) {
      video_reportsData = reportvideo_val.map((items, index) => (
        <div id={'reportsvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditVideoReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'videoReport'
              }
              toggle={this.OpenEditVideoReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items.video_id}
                {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditVideoReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={(e) => this.handleVideoReportSubmit(e)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='videoReportcomment'
                          name='videoReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.videoReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditVideoReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={() => this.beginVideos(items, 1)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'videoReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'videoReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items.video_id}
                {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactType === 'videoReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactType === 'videoReport' &&
                this.state.contactID === items.id &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsVideo.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else {
      video_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportsvideo1.length) {
      video_reportsData1 = reportvideo_val1.map((items, index) => (
        <div id={'reportsvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditVideoReport1.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus1 &&
                this.state.reportEditId1 === items.id &&
                this.state.type1 === 'videoReport1'
              }
              toggle={this.OpenEditVideoReport1}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items.video_id}
                {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditVideoReport1}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={(e) => this.handleVideoReportSubmit1(e)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='videoReportcomment'
                          name='videoReport1'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange1.bind(this)}
                          value={this.state.videoReport1}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage1}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditVideoReport1}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this.beginVideos.bind(this, items, 2)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'videoReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'videoReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items.video_id}
                {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactType === 'videoReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactType === 'videoReport' &&
                this.state.contactID === items.id &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsVideo1.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else {
      video_reportsData1 = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    // if(this.state.progress_bar_zero.length)
    // {
    //   progress_bar_data=progress_bar_zero_val.map((item,index)=>
    //     <tr key={index}>

    //         <td>
    //             <div className="question_row">
    //                 <div className="question_count">
    //                    Q{item.chapter_no}
    //                 </div>
    //                 <div className="question_bar">
    //                     <p>{item.chapter_name}</p>
    //                     <div className="bar_wrap">
    //                         <CountProgressinfo_zero chapter_id={item.chapter_id}  idname={this.state.idname} token={this.state.token} answered_state={index} tot_count={item.question_stat_count} startDate={this.state.send_startDate} endDate={this.state.send_startDate_second}/>
    //                     </div>
    //                 </div>
    //             </div>
    //         </td>
    //     </tr>

    //   );
    // }

    return (
      <div>
        <div className='animated fadeIn'>
          <EmailResubscribe />
          <div className='row'>
            <div className='col-md-12 margin_bottom_20 frm_title_logo_wrap'>
              <h1 className='section_head'>{language.LC().DASHBOARD}</h1>
              <img
                src={App_data.frontend_url + '/img/GARP_logo.png'}
                className='garpLogo'
                alt='full logo'
              />
            </div>
            <div className='col-md-12 margin_bottom_20'>
              <div className='dashboard-top-head-section'>
                <h1 className='section_head'> {language.LC().MY_FRM_EXAM_I_DASHBOARD} </h1>
                <div className='dashboard-right-side-btn'>
                  <button className='btn btn-primary' onClick={this._viewAllQuestion.bind()}>
                    {' '}
                    {language.LC().Detailed_Stats}{' '}
                  </button>
                </div>
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='card margin_bottom_20'>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-1 text-md-right align-self-center'>
                      <label className='margin_bottom_0'> {language.LC().FROM} </label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          selected={this.state.startDate}
                          onChange={this.handleChange}
                          placeholderText='Select date'
                          width='100%'
                        />
                      </div>
                    </div>
                    <div className='col-sm-1 text-md-center align-self-center'>
                      <label className='margin_bottom_0'> {language.LC().TO} </label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          placeholderText='Select date'
                          width='100%'
                          selected={this.state.startDate_second}
                          minDate={this.state.startDate}
                          onChange={this.handleChange_second.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().PERFORMANCE}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                  </div>
                  <div className='chart-wrapper performance-chart-wrapper'>
                    <Bar
                      data={bar_data}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='col-sm-12 text-center'>
                {/*<button className="btn btn-primary" onClick={this._getall}>{this.state.more_detail_button}</button>*/}
              </div>

              <div className={this.state.show_outer} id='outer_readings_id'>
                {/*reading_data*/}
              </div>

              {/* ----------------------- Saved  ------------- */}

              <div className='padding_bottom_30'>
                {' '}
                <h1 className='section_head padding_bottom_30'>
                  {language.LC().MY_SAVED_ITEM_WITH_FLASH_CARD}
                </h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.savedTabToggle('1');
                      }}
                      className={activeTabSaved === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>
                    <li
                      onClick={() => {
                        this.savedTabToggle('2');
                      }}
                      className={activeTabSaved === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    {this.state.isVideo ? (
                      <li
                        onClick={() => {
                          this.savedTabToggle('3');
                        }}
                        className={activeTabSaved === '3' ? 'active' : ''}
                      >
                        <span> {language.LC().VIDEOS} </span>
                      </li>
                    ) : null}
                  </ul>
                </div>
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabSaved === '1'
                        ? savedquestion_data
                        : this.state.activeTabSaved === '2'
                          ? savednotes_data
                          : savedvideos_data}
                    </div>
                  </div>
                </div>
              </div>

              {/* ----------------------- Reports ------------- */}

              <div className='padding_bottom_30'>
                <h1 className='section_head padding_bottom_30'>{language.LC().MY_REPORTS}</h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.reportsTabToggle('1');
                      }}
                      className={activeTabReports === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>
                    <li
                      onClick={() => {
                        this.reportsTabToggle('2');
                      }}
                      className={activeTabReports === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    {this.state.isVideo ? (
                      <li
                        onClick={() => {
                          this.reportsTabToggle('3');
                        }}
                        className={activeTabReports === '3' ? 'active' : ''}
                      >
                        <span> {language.LC().VIDEOS} </span>
                      </li>
                    ) : null}
                    <li
                      onClick={() => {
                        this.reportsTabToggle('4');
                      }}
                      className={activeTabReports === '4' ? 'active' : ''}
                    >
                      <span> Mocks</span>
                    </li>
                  </ul>
                </div>

                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabReports === '1'
                        ? question_reportsData
                        : this.state.activeTabReports === '2'
                          ? notes_reportsData
                          : this.state.activeTabReports === '3'
                            ? video_reportsData
                            : cbt_reportsData}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-4'>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().QUESTION_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='1'
                      id='1'
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {qpLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.questionProgressBarFun()}</tbody>
                    )}
                  </table>
                </div>
              </div>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().NOTES_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='2'
                      id='2'
                      content={this.state.tooltips[2].placement}
                      place_tip={this.state.tooltips[2].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {npLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.notesProgressBarFun()}</tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.toggleAlert}
            className={'modal-primary ' + this.props.className}
          >
            {/* <ModalHeader toggle={this.toggleClose}>{this.state.MessageTitle}</ModalHeader>*/}
            <ModalHeader>
              {language.LC().ALERT}
              <button type='button' className='close' aria-label='Close' onClick={this.toggleClose}>
                <span aria-hidden='true'>×</span>
              </button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.toggleDone}
                >
                  {' '}
                  {language.LC().OK}{' '}
                </Button>
              </div>
            </ModalBody>
            {/*<ModalFooter>
                    <Button className="btn btn-sm btn-secondary" color="secondary" onClick={this.toggleClose}>Cancel</Button>
                </ModalFooter>*/}
          </Modal>
          <div className='row'>
            <div className='col-md-12 margin_bottom_20'>
              <div className='dashboard-top-head-section'>
                <h1 className='section_head'> {language.LC().MY_FRM_EXAM_II_DASHBOARD} </h1>
                <div className='dashboard-right-side-btn'>
                  <button className='btn btn-primary' onClick={this._viewAllQuestion1.bind()}>
                    {' '}
                    {language.LC().Detailed_Stats}{' '}
                  </button>
                </div>
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='card margin_bottom_20'>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-1 text-md-right align-self-center'>
                      <label className='margin_bottom_0'>{language.LC().FROM}</label>
                    </div>

                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          selected={this.state.startDate1}
                          onChange={this.handleChange1}
                          placeholderText='Select date'
                          width='100%'
                        />
                      </div>
                    </div>
                    <div className='col-sm-1 text-md-center align-self-center'>
                      <label className='margin_bottom_0'> {language.LC().TO} </label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          placeholderText='Select date'
                          width='100%'
                          selected={this.state.startDate_second1}
                          minDate={this.state.startDate1}
                          onChange={this.handleChange_second1.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().PERFORMANCE}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='3'
                      id='3'
                      content={this.state.tooltips[3].placement}
                      place_tip={this.state.tooltips[3].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                  </div>
                  <div className='chart-wrapper'>
                    <Bar
                      data={bar_data1}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='col-sm-12 text-center'>
                {/* <button className="btn btn-primary" onClick={this._getall}>{this.state.more_detail_button}</button>*/}
              </div>

              <div className={this.state.show_outer} id='outer_readings_id'>
                {/*reading_data*/}
              </div>

              {/* ----------------------- Saved  ------------- */}

              <div className='padding_bottom_30'>
                {' '}
                <h1 className='section_head padding_bottom_30'>
                  {language.LC().MY_SAVED_ITEM_WITH_FLASH_CARD}
                </h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.savedTabToggle1('1');
                      }}
                      className={activeTabSaved1 === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>
                    <li
                      onClick={() => {
                        this.savedTabToggle1('2');
                      }}
                      className={activeTabSaved1 === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    {this.state.isVideo ? (
                      <li
                        onClick={() => {
                          this.savedTabToggle1('3');
                        }}
                        className={activeTabSaved1 === '3' ? 'active' : ''}
                      >
                        <span> {language.LC().VIDEOS} </span>
                      </li>
                    ) : null}
                  </ul>
                </div>
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabSaved1 === '1'
                        ? savedquestion_data1
                        : this.state.activeTabSaved1 === '2'
                          ? savednotes_data1
                          : this.state.activeTabSaved1 === '3'
                            ? savedvideos_data1
                            : null}
                    </div>
                  </div>
                </div>
              </div>

              {/* ----------------------- Reports ------------- */}

              <div className=''>
                <h1 className='section_head padding_bottom_30'>{language.LC().MY_REPORTS}</h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.reportsTabToggle1('1');
                      }}
                      className={activeTabReports1 === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>
                    <li
                      onClick={() => {
                        this.reportsTabToggle1('2');
                      }}
                      className={activeTabReports1 === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    {this.state.isVideo ? (
                      <li
                        onClick={() => {
                          this.reportsTabToggle1('3');
                        }}
                        className={activeTabReports1 === '3' ? 'active' : ''}
                      >
                        <span> {language.LC().VIDEOS} </span>
                      </li>
                    ) : null}
                    <li
                      onClick={() => {
                        this.reportsTabToggle1('4');
                      }}
                      className={activeTabReports1 === '4' ? 'active' : ''}
                    >
                      <span> Mocks</span>
                    </li>
                  </ul>
                </div>

                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabReports1 === '1'
                        ? question_reportsData1
                        : this.state.activeTabReports1 === '2'
                          ? notes_reportsData1
                          : this.state.activeTabReports1 === '3'
                            ? video_reportsData1
                            : this.state.activeTabReports1 === '4'
                              ? cbt_reportsData1
                              : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-4'>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().QUESTION_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='4'
                      id='4'
                      content={this.state.tooltips[4].placement}
                      place_tip={this.state.tooltips[4].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {qpLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.questionProgressBarFun1()}</tbody>
                    )}
                  </table>
                </div>
              </div>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().NOTES_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='5'
                      id='5'
                      content={this.state.tooltips[5].placement}
                      place_tip={this.state.tooltips[5].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {npLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.notesProgressBarFun1()}</tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>

          <Modal
            isOpen={this.state.alert_status1}
            toggle={this.toggleAlert1}
            className={'modal-primary ' + this.props.className}
          >
            {/* <ModalHeader toggle={this.toggleClose}>{this.state.MessageTitle}</ModalHeader>*/}
            <ModalHeader>
              {language.LC().ALERT}
              <button
                type='button'
                className='close'
                aria-label='Close'
                onClick={this.toggleClose1}
              >
                <span aria-hidden='true'>×</span>
              </button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.toggleDone1}
                >
                  {' '}
                  {language.LC().OK}{' '}
                </Button>
              </div>
            </ModalBody>
            {/*<ModalFooter>
                    <Button className="btn btn-sm btn-secondary" color="secondary" onClick={this.toggleClose}>Cancel</Button>
                </ModalFooter>*/}
          </Modal>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

// function CountProgressinfo_zero(props) {
//     var data={'idname':props.idname,'chapter_id':props.chapter_id,'token':props.token,'tot_count':props.tot_count,startDate:props.startDate,endDate:props.endDate};
//     FD.callAPI(App_data.backend_api+'/frm_dashboard/getCountquesprogByuser',data).then(resp => {
//       var dataString = JSON.stringify(resp);
//       var dataReason = JSON.parse(dataString);
//       var progresstotalques_zero=props.tot_count;
//       var progressnotes_zero=Math.round(((dataReason.progressbarzero_data[0].counttotquestion)/progresstotalques_zero)*100);
//       if(progressnotes_zero<1)
//       {
//         document.getElementById('user_question_status'+props.answered_state).innerHTML = '<Progress className="progress-xs" color="info" value="1" style="width:1%;" />';
//       }
//       else{
//         document.getElementById('user_question_status'+props.answered_state).innerHTML = '<Progress className="progress-xs" color="info" value="'+progressnotes_zero+'" style="width:'+progressnotes_zero+'%;" />';
//       }
//     })
//    return (<div id={'user_question_status'+props.answered_state}></div>);
// }

var bar_data_sub = [];
// var reading_text = "";
function Barget(props) {
  let data = {};
  if (props.subreadings_status && props.endDate !== '') {
    data = {
      idname: props.idname,
      chapter_id: props.chapter_id,
      token: props.token,
      startDate: props.startDate,
      endDate: props.endDate,
      level: 2,
    };
  } else {
    data = {
      idname: props.idname,
      chapter_id: props.chapter_id,
      token: props.token,
      startDate: '',
      endDate: '',
      level: 2,
    };
  }

  FD.callAPI(App_data.backend_api + '/frm_dashboard/subProgressbar', data).then((resp) => {
    FD.callAPI(App_data.backend_api + '/frm_dashboard/subProgressbarofclass', data).then(
      (resp_class) => {
        /*class variable */
        var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
        var dataReason_class = JSON.parse(dataString_class);

        var final_array_main_class = [];

        for (i = 0; i < dataReason_class.length; i++) {
          var right_answered_class = dataReason_class[i].right_answer;
          var total_question_class = dataReason_class[i].total_questions_frms;
          var user_graph_val_class = Math.round(
            (right_answered_class / total_question_class) * 100,
          );
          final_array_main_class.push(user_graph_val_class);
        }
        //  console.log('abc------------------'+final_array_main_class+'-------ssss--------');
        /*user variable*/
        var dataString = JSON.stringify(resp.readingwisebar_ret);
        var dataReason = JSON.parse(dataString);

        var final_array_main = [];
        var reading_text = [];

        for (i = 0; i < dataReason.length; i++) {
          var right_answered = dataReason[i].right_answer;
          var total_question = dataReason[i].total_questions_frms;

          var user_graph_val = ((right_answered / total_question) * 100).toFixed(2);
          final_array_main.push(user_graph_val);
          reading_text.push(dataReason[i].reading.substring(0, 10));
        }
        /*graph details*/
        bar_data_sub[props.answered_state] = {
          labels: reading_text,
          datasets: [
            {
              label: 'You',
              backgroundColor: 'rgb(114,195,250)',
              borderWidth: 1,
              hoverBackgroundColor: 'rgb(114,195,250)',
              data: final_array_main,
            },
            {
              label: 'AnalystPrep Users Average',
              backgroundColor: 'rgb(42,63,84)',
              borderWidth: 1,
              hoverBackgroundColor: 'rgb(42,63,84)',
              data: final_array_main_class,
            },
          ],
        };
      },
    );
  });
  return (
    <Bar
      data={bar_data_sub[props.answered_state]}
      options={{
        maintainAspectRatio: false,
        // animation: {
        //   duration: 1000,
        //   delay: 1000,
        //   from: 1,
        //   to: 0,
        //   easing: 'linear',
        // },
      }}
    />
  );
}
class TooltipItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id}></i>*/}
        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}
export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/FRM/Frmdashboard/Frmdashboard.js